/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 2);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Rectangle_1 = __webpack_require__(16);
var Point_1 = __webpack_require__(14);
var IncidentManager_1 = __webpack_require__(27);
var GafManager_1 = __webpack_require__(13);
var Physics_1 = __webpack_require__(29);
var ArrayUtil_1 = __webpack_require__(1);
var PostOffice_1 = __webpack_require__(15);
var Framework = (function (_super) {
    __extends(Framework, _super);
    function Framework() {
        var _this = _super.call(this) || this;
        _this._renderFps = 30;
        _this._renderSpf = 0;
        _this._nextRenderTime = 0;
        _this._inited = false;
        _this.speed = 0.01;
        _this.frame = 0;
        _this.lastFrameTime = 0;
        _this.fpsCalcStartTime = 0;
        _this.fpsCaclFrames = 0;
        _this._stageSize = new Point_1.Point(800, 600);
        _this._fullscreenRect = new Rectangle_1.Rectangle();
        _this.gafManager = new GafManager_1.GafManager();
        _this._loader = null;
        _this._delayFunctionObjects = [];
        _this._updateFunctions = [];
        _this._updateFunctionTargets = [];
        return _this;
    }
    Framework.prototype.initialize = function (stageWidth, stageHeight, debug) {
        this._stageSize.set(stageWidth, stageHeight);
        this.renderer = PIXI.autoDetectRenderer(this._stageSize.x, this._stageSize.y, { antialias: true });
        this.renderer.autoResize = true;
        this.stage = new PIXI.Container();
        this.root = new PIXI.Container();
        this.stage.addChild(this.root);
        this.postOffice = new PostOffice_1.PostOffice(this);
        this.incidentsManager = new IncidentManager_1.IncidentManager(this);
        this._animeteBinded = this.animate.bind(this);
        this.renderFps = 30;
        // run the render loop
        requestAnimationFrame(this._first_animate.bind(this));
        window.onresize = this._onWindowResize.bind(this);
        this._onWindowResize();
        if (debug) {
            this._setDebug();
        }
        exports.FW.addUpdateFunction(this, this._loadResources);
    };
    Object.defineProperty(Framework.prototype, "initialized", {
        get: function () {
            return this._inited;
        },
        enumerable: true,
        configurable: true
    });
    Framework.prototype.refresh = function () {
        document.location.reload();
    };
    Object.defineProperty(Framework.prototype, "stageWidth", {
        get: function () {
            return this._stageSize.x;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "stageHeight", {
        get: function () {
            return this._stageSize.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Framework.prototype, "fullscreenRect", {
        get: function () {
            return this._fullscreenRect;
        },
        enumerable: true,
        configurable: true
    });
    Framework.prototype.stagePointToScreen = function (x, y) {
        return new Point_1.Point((window.innerWidth - this.stageWidth * this.stage.scale.x) / 2 + x * this.stage.scale.x, (window.innerHeight - this.stageHeight * this.stage.scale.y) / 2 + y * this.stage.scale.y);
    };
    Framework.prototype.addPreloadResource = function (name, url) {
        if (this._loader == null) {
            this._loader = new PIXI.loaders.Loader();
        }
        console.log('addPreloadResource: ' + name);
        this._loader.add(name, url);
        if (this.initialized) {
            exports.FW.addUpdateFunction(this, this._loadResources);
        }
    };
    Framework.prototype.getPreloadedResource = function (name) {
        return this._loader ? this._loader.resources[name] : null;
    };
    Framework.prototype._onWindowResize = function () {
        var width = window.innerWidth;
        var height = window.innerHeight;
        this.renderer.resize(width, height);
        var scaleX = width / this._stageSize.x;
        var scaleY = height / this._stageSize.y;
        var scale = Math.min(scaleX, scaleY);
        this.stage.scale.set(scale);
        var scaledWidth = this._stageSize.x * scale;
        var scaledHeight = this._stageSize.y * scale;
        this.stage.position.set((width - scaledWidth) / 2, (height - scaledHeight) / 2);
        this._fullscreenRect.width = width / scale;
        this._fullscreenRect.height = height / scale;
        this._fullscreenRect.x = -this.stage.position.x / scale;
        this._fullscreenRect.y = -this.stage.position.y / scale;
        this.emit(Framework.EVENT.STAGE_RESIZE);
    };
    Object.defineProperty(Framework.prototype, "physics", {
        get: function () {
            if (this._physics == null) {
                this._physics = new Physics_1.Physics(this);
            }
            return this._physics;
        },
        enumerable: true,
        configurable: true
    });
    Framework.prototype._loadResources = function () {
        exports.FW.removeUpdateFunction(this, this._loadResources);
        this.gafManager._loadGafs();
        if (this.gafManager.isLoading()) {
            this.gafManager.once(GafManager_1.GafManager.EVENT.LOAD_COMPLETE, this._init_gaf_loaded, this);
        }
        else {
            this._init_gaf_loaded();
        }
    };
    Framework.prototype._init_gaf_loaded = function () {
        if (this._loader) {
            console.log('loader.load()');
            this._loader.once("complete", this._init_pixi_loaded, this);
            this._loader.load();
        }
        else {
            this.addDelayFunction(this, this._init_pixi_loaded, null, 1);
        }
    };
    Framework.prototype._init_pixi_loaded = function () {
        var _this = this;
        if (window["liquidfunReady"]) {
            this._inited = true;
            setTimeout(function () { return _this.emitPreloadComplete(); }, 50);
        }
        else {
            setTimeout(function () { return _this._init_pixi_loaded(); }, 50);
        }
    };
    Framework.prototype.emitPreloadComplete = function () {
        document.body.appendChild(this.renderer.view);
        this.emit(Framework.EVENT.PRELOAD_COMPLETE);
    };
    Object.defineProperty(Framework.prototype, "renderFps", {
        get: function () {
            return this._renderFps;
        },
        set: function (value) {
            this._renderFps = value;
            this._renderSpf = 1000 / this._renderFps;
        },
        enumerable: true,
        configurable: true
    });
    Framework.prototype._setDebug = function () {
        this.debugRoot = new PIXI.Container();
        this.stage.addChild(this.debugRoot);
        if (this._physics) {
            this.physics.createDebugRoot(this.debugRoot);
        }
        this.createFpsField();
    };
    Framework.prototype.addUpdateFunction = function (owner, func) {
        var index = this._updateFunctions.indexOf(func);
        while (index != -1) {
            if (this._updateFunctionTargets[index] == owner)
                return;
            index = this._updateFunctions.indexOf(func, index + 1);
        }
        this._updateFunctions.push(func);
        this._updateFunctionTargets.push(owner);
    };
    Framework.prototype.removeUpdateFunction = function (owner, func) {
        var index = this._updateFunctions.indexOf(func);
        while (index != -1) {
            if (this._updateFunctionTargets[index] == owner) {
                this._updateFunctions[index] = null;
                this._updateFunctionTargets[index] = null;
                return;
            }
            index = this._updateFunctions.indexOf(func, index + 1);
        }
    };
    ;
    Framework.prototype.addDelayFunction = function (owner, func, param, delayMs) {
        if (param === void 0) { param = null; }
        if (delayMs === void 0) { delayMs = 0; }
        var obj = {
            owner: owner,
            func: func,
            param: param,
            time: this.lastFrameTime + delayMs
        };
        this._delayFunctionObjects.push(obj);
        this._delayFunctionObjects = ArrayUtil_1.ArrayUtil.sortNumericOn(this._delayFunctionObjects, "time", true);
        return obj;
    };
    ;
    Framework.prototype.createFpsField = function () {
        this.fpsField = new PIXI.Text('PIXI.js', {
            fontFamily: 'Arial',
            fontSize: '10px',
            fontStyle: 'italic',
            fontWeight: 'bold',
            fill: '#F7EDCA',
            stroke: '#4a1850',
            strokeThickness: 5
        });
        this.fpsField.x = 0;
        this.fpsField.y = this._stageSize.y;
        this.fpsField.anchor.set(0, 1);
        this.stage.addChild(this.fpsField);
    };
    Framework.prototype._first_animate = function (currentTime) {
        this.lastFrameTime = currentTime;
        requestAnimationFrame(this._animeteBinded);
        this.renderer.render(this.stage);
        this._nextRenderTime = currentTime + this._renderSpf;
    };
    Framework.prototype.animate = function (currentTime) {
        requestAnimationFrame(this._animeteBinded);
        if (this.fpsField) {
            if (this.fpsCalcStartTime == 0) {
                this.fpsCalcStartTime = currentTime;
                this.fpsCaclFrames = 0;
            }
            else if (currentTime - this.fpsCalcStartTime > 1000) {
                var fps = Math.round(this.fpsCaclFrames / (currentTime - this.fpsCalcStartTime) * 1000);
                this.fpsField.text = "FPS: " + fps;
                this.fpsCalcStartTime = currentTime;
                this.fpsCaclFrames = 0;
            }
            else {
                this.fpsCaclFrames++;
            }
        }
        ++this.frame;
        var deltaTime = currentTime - this.lastFrameTime;
        this.lastFrameTime = currentTime;
        PIXI.keyboardManager.update();
        TWEEN.update();
        this.callUpdateFunctions(deltaTime);
        if (currentTime > this._nextRenderTime && this._inited) {
            this._nextRenderTime += this._renderSpf;
            this.renderer.render(this.stage);
        }
    };
    Framework.prototype.emptyAnimate = function (currentTime) {
        this.fpsCalcStartTime = 0;
        this.lastFrameTime = currentTime;
        requestAnimationFrame(this._animeteBinded);
    };
    Framework.prototype.setActive = function (active) {
        if (active) {
            this._animeteBinded = this.animate.bind(this);
        }
        else {
            this._animeteBinded = this.emptyAnimate.bind(this);
        }
    };
    Framework.prototype.callUpdateFunctions = function (deltaTime) {
        while (this._delayFunctionObjects.length) {
            var delayObj = this._delayFunctionObjects[0];
            if (delayObj.time > this.lastFrameTime) {
                break;
            }
            this._delayFunctionObjects.shift();
            if (delayObj.disposed) {
                continue;
            }
            if (delayObj.owner)
                delayObj.func.apply(delayObj.owner, [delayObj.param]);
            else
                delayObj.func(delayObj.param);
        }
        var len = this._updateFunctions.length;
        for (var index = 0; index < len; ++index) {
            if (this._updateFunctions[index] == null) {
                this._updateFunctions.splice(index, 1);
                this._updateFunctionTargets.splice(index, 1);
                --index;
                --len;
            }
            else {
                var owner = this._updateFunctionTargets[index];
                var func = this._updateFunctions[index];
                func.call(owner, deltaTime);
            }
        }
    };
    Object.defineProperty(Framework.prototype, "time", {
        get: function () {
            return this.lastFrameTime;
        },
        enumerable: true,
        configurable: true
    });
    Framework.prototype.getSound = function (alias) {
        var resource = exports.FW.getPreloadedResource(alias);
        return resource ? resource["sound"] : null;
    };
    Framework.prototype.playSound = function (alias, options) {
        var sound = this.getSound(alias);
        if (sound) {
            return sound.play(options);
        }
        return null;
    };
    Framework.prototype.hitTest = function (globalPoint, root) {
        var manager = this.renderer['plugins']['interaction'];
        return manager['hitTest'](globalPoint, root);
    };
    Framework.EVENT = {
        PRELOAD_COMPLETE: "preload-complete",
        STAGE_RESIZE: 'stage-resize'
    };
    return Framework;
}(PIXI.utils.EventEmitter));
exports.Framework = Framework;
exports.FW = new Framework();


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtil = (function () {
    function ArrayUtil() {
    }
    ArrayUtil.swapElements = function (array, index1, index2) {
        var el = array[index1];
        array[index1] = array[index2];
        array[index2] = el;
    };
    ArrayUtil.removeElement = function (array, element) {
        var index = array.indexOf(element);
        if (index == -1)
            return false;
        array.splice(index, 1);
        return true;
    };
    ArrayUtil.addUniqueElement = function (array, element) {
        if (array.indexOf(element) != -1)
            return false;
        array.push(element);
        return true;
    };
    ArrayUtil.sortNumeric = function (arr, ascending) {
        if (ascending) {
            arr.sort(function (a, b) { return a - b; });
        }
        else {
            arr.sort(function (a, b) { return b - a; });
        }
        return arr;
    };
    ArrayUtil.sortNumericOn = function (arr, key, ascending) {
        if (ascending) {
            arr.sort(function (a, b) { return a[key] - b[key]; });
        }
        else {
            arr.sort(function (a, b) { return b[key] - a[key]; });
        }
        return arr;
    };
    ArrayUtil.setElementIndex = function (array, element, index) {
        var order = array.indexOf(element);
        if (order == -1)
            return -1;
        index = Math.max(0, Math.min(array.length - 1, index));
        if (index != order) {
            array.splice(order, 1);
            array.splice(index, 0, element);
        }
        return index;
    };
    ArrayUtil.convertXMLAttributesToJson = function (node) {
        var json = {};
        for (var i = 0; i < node.attributes.length; ++i) {
            var value = node.attributes[i].value;
            if (value == 'true') {
                value = true;
            }
            else if (value == 'false') {
                value = false;
            }
            json[node.attributes[i].name] = value;
        }
        return json;
    };
    return ArrayUtil;
}());
exports.ArrayUtil = ArrayUtil;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AboutScreen_1 = __webpack_require__(20);
var SoundManager_1 = __webpack_require__(11);
var LevelSelectScreen_1 = __webpack_require__(22);
var GameCover_1 = __webpack_require__(21);
var Framework_1 = __webpack_require__(0);
var MainCover_1 = __webpack_require__(23);
var WorldInfo_1 = __webpack_require__(7);
var app_base_1 = __webpack_require__(10);
var App = (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super.call(this) || this;
        Framework_1.FW.gafManager.addGafToLoad('worlds', 'assets/gaf');
        Framework_1.FW.gafManager.addGafToLoad('popups', 'assets/gaf');
        Framework_1.FW.addPreloadResource('worlds.xml', 'assets/xml/worlds.xml');
        Framework_1.FW.initialize(720, 405, false);
        Framework_1.FW.renderer.view.style.opacity = '0';
        Framework_1.FW.stage.interactiveChildren = false;
        Framework_1.FW.once(Framework_1.Framework.EVENT.PRELOAD_COMPLETE, _this.onAssetsLoaded, _this);
        _this.reset();
        Framework_1.FW.on(Framework_1.Framework.EVENT.STAGE_RESIZE, _this.refreshKidSafeBadge, _this);
        _this.refreshKidSafeBadge();
        return _this;
    }
    App.prototype.refreshKidSafeBadge = function () {
        var p = Framework_1.FW.stagePointToScreen(0, 0);
        $('.kidsafe').css('right', (p.x + 30) + 'px');
        $('.kidsafe').css('bottom', (p.y + 20) + 'px');
    };
    App.prototype.onAssetsLoaded = function () {
        this.showCover();
        Framework_1.FW.addUpdateFunction(this, this.fadeInUpdate);
        WorldInfo_1.importWorldXML(Framework_1.FW.getPreloadedResource('worlds.xml').data);
        SoundManager_1.soundManager.importSoundXML(Framework_1.FW.getPreloadedResource('worlds.xml').data);
    };
    App.prototype.fadeInUpdate = function (dt) {
        var timePassed = new Date().getTime() - window['pageStartTime'];
        if (timePassed < 3000) {
            return;
        }
        var opacity = parseFloat(Framework_1.FW.renderer.view.style.opacity);
        opacity = Math.min(1, opacity + dt * 0.01);
        Framework_1.FW.renderer.view.style.opacity = '' + opacity;
        if (opacity == 1) {
            Framework_1.FW.stage.interactiveChildren = true;
            Framework_1.FW.removeUpdateFunction(this, this.fadeInUpdate);
        }
    };
    App.prototype.showAbout = function () {
        this.reset();
        new AboutScreen_1.AboutScreen();
    };
    App.prototype.showCover = function () {
        this.reset();
        new MainCover_1.MainCover();
    };
    App.prototype.showGameCover = function () {
        this.reset();
        new GameCover_1.GameCover();
    };
    App.prototype.enterWorld = function (_code) {
        if (_code) {
            this.reset();
            new LevelSelectScreen_1.LevelSelectScreen({
                code: _code
            });
        }
    };
    return App;
}(app_base_1.AppBase));
exports.app = new App();


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var app_base_1 = __webpack_require__(10);
var WorldInfo_1 = __webpack_require__(7);
var LevelInfo_1 = __webpack_require__(8);
var UserRecord = (function (_super) {
    __extends(UserRecord, _super);
    function UserRecord() {
        var _this = _super.call(this) || this;
        _this.json = {};
        _this.refresh();
        return _this;
    }
    UserRecord.prototype.refresh = function () {
        this.json = Cookies.getJSON('userRecord') || {};
        console.log('cookie loaded: ' + JSON.stringify(this.json));
    };
    UserRecord.prototype.save = function () {
        Cookies.set('userRecord', this.json);
    };
    UserRecord.prototype.setAudioPlayed = function (audio) {
        this.json.audios = this.json.audios || {};
        if (!this.json.audios[audio]) {
            this.json.audios[audio] = {};
            this.save();
        }
    };
    UserRecord.prototype.isAudioPlayed = function (audio) {
        var audios = this.json.audios || {};
        return audios[audio];
    };
    UserRecord.prototype.getLevelRecord = function (level) {
        var levels = this.json.levels || {};
        var json = levels[level];
        if (json) {
            return new LevelRecord(level, json);
        }
        return null;
    };
    UserRecord.prototype.setLevelRecord = function (level, record) {
        if (record) {
            var currentRecord = this.getLevelRecord(level);
            if (currentRecord == null || currentRecord.stars < record.stars || currentRecord.time > record.time) {
                var levels = this.json.levels || {};
                levels[level] = record.json;
                this.json.levels = levels;
                this.save();
                this.emit(UserRecord.EVENT.LEVEL_RECORD_CHANGE);
                return true;
            }
        }
        return false;
    };
    UserRecord.prototype.hasLevelRecord = function (level) {
        var levels = this.json.levels || {};
        return levels.hasOwnProperty(level) && levels[level];
    };
    UserRecord.prototype.isWorldLocked = function (_worldCode) {
        if (app_base_1.AppBase.debug) {
            return false;
        }
        else {
            var worldIndex = WorldInfo_1.getWorld(_worldCode).index;
            return worldIndex > 0 && !this.isWorldComplete(WorldInfo_1.WorldList[worldIndex - 1].code);
        }
    };
    UserRecord.prototype.isWorldComplete = function (worldCode) {
        var level = LevelInfo_1.LevelInfo.getLevel(worldCode, 0);
        return this.hasLevelRecord(level.level) || WorldInfo_1.getWorld(worldCode).index <= 0;
    };
    UserRecord.prototype.getWorldProgress = function (worldCode) {
        var stars = 0;
        for (var i = 0; i <= 10; ++i) {
            var level = LevelInfo_1.LevelInfo.getLevel(worldCode, i);
            var record = this.getLevelRecord(level.level);
            if (record) {
                stars += record.stars;
            }
        }
        // 33 stars total for a world ( 10 lvs + challenge ) * 3
        return stars / 33;
    };
    UserRecord.prototype.isLevelLocked = function (_level) {
        if (app_base_1.AppBase.debug) {
            return false;
        }
        else {
            var info = LevelInfo_1.LevelInfo.fromString(_level);
            if (info.index == 1) {
                return false;
            }
            if (info.index == 0) {
                return !this.hasLevelRecord(LevelInfo_1.LevelInfo.getLevel(info.worldCode, 10).level);
            }
            return !this.hasLevelRecord(info.getNeighbor(-1).level);
        }
    };
    UserRecord.EVENT = {
        LEVEL_RECORD_CHANGE: 'levelRecordChange'
    };
    return UserRecord;
}(PIXI.utils.EventEmitter));
exports.UserRecord = UserRecord;
var LevelRecord = (function () {
    function LevelRecord(level, json) {
        this.level = level;
        this.json = json;
    }
    Object.defineProperty(LevelRecord.prototype, "stars", {
        get: function () {
            return this.json.stars || 0;
        },
        set: function (value) {
            this.json.stars = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelRecord.prototype, "time", {
        get: function () {
            return this.json.time || 0;
        },
        set: function (value) {
            this.json.time = value;
        },
        enumerable: true,
        configurable: true
    });
    return LevelRecord;
}());
exports.LevelRecord = LevelRecord;
exports.userRecord = new UserRecord();


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MathUtil = (function () {
    function MathUtil() {
    }
    Object.defineProperty(MathUtil, "ONE_SECOND", {
        get: function () {
            return 1000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MathUtil, "ONE_MINUTE", {
        get: function () {
            return 60000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MathUtil, "ONE_HOUR", {
        get: function () {
            return 3600000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MathUtil, "ONE_DAY", {
        get: function () {
            return 86400000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MathUtil, "ONE_WEEK", {
        get: function () {
            return 604800000;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MathUtil, "HALF_PI", {
        get: function () {
            return MathUtil._HALF_PI;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MathUtil, "TWO_PI", {
        get: function () {
            return MathUtil._TWO_PI;
        },
        enumerable: true,
        configurable: true
    });
    MathUtil.radians2degrees = function (inRadians) {
        return inRadians * MathUtil._180_DIVIDED_BY_PI;
    };
    MathUtil.degrees2radians = function (inDegrees) {
        return inDegrees * MathUtil._PI_DIVIDED_BY_180;
    };
    MathUtil.radiansFollowTarget = function (radians, target, rate, minRadians, maxRadians) {
        if (minRadians === void 0) { minRadians = 1; }
        if (maxRadians === void 0) { maxRadians = Number.MAX_VALUE; }
        var dr = target - radians;
        while (dr > Math.PI)
            dr -= MathUtil.TWO_PI;
        while (dr < -Math.PI)
            dr += MathUtil.TWO_PI;
        return MathUtil.numberFollowTarget(target - dr, target, rate, minRadians, maxRadians);
    };
    MathUtil.numberFollowTarget = function (num, target, rate, minDistance, maxDistance) {
        if (minDistance === void 0) { minDistance = 0; }
        if (maxDistance === void 0) { maxDistance = Number.MAX_VALUE; }
        var dx = target - num;
        if (Math.abs(dx) > minDistance) {
            var movex = dx * rate;
            var absMovex = Math.abs(movex);
            if (absMovex < minDistance) {
                movex = dx > 0 ? minDistance : -minDistance;
            }
            else if (absMovex > maxDistance) {
                movex = dx > 0 ? maxDistance : -maxDistance;
            }
            return num + movex;
        }
        return target;
    };
    MathUtil.pointFollowTarget = function (point, target, rate, minDistance, maxDistance) {
        if (minDistance === void 0) { minDistance = 0; }
        if (maxDistance === void 0) { maxDistance = Number.MAX_VALUE; }
        var dx = target.x - point.x;
        var dy = target.y - point.y;
        var distance = Math.sqrt(dx * dx + dy * dy);
        if (distance > minDistance) {
            var len = Math.min(maxDistance, Math.max(minDistance, distance * rate));
            var scale = len / distance;
            point.x += dx * scale;
            point.y += dy * scale;
        }
        else {
            point.x = target.x;
            point.y = target.y;
        }
    };
    MathUtil.formatTimer = function (time, showMs) {
        if (showMs === void 0) { showMs = true; }
        var mins = Math.floor(time / 60000);
        time -= mins * 60000;
        var secs = Math.floor(time / 1000);
        time -= secs * 1000;
        var msecs = Math.floor(time);
        var mstr = "" + mins;
        while (mstr.length < 1)
            mstr = "0" + mstr;
        while (mstr.length < 2)
            mstr = " " + mstr;
        var sstr = "" + secs;
        while (sstr.length < 2)
            sstr = "0" + sstr;
        var msstr = "" + msecs;
        while (msstr.length < 2)
            msstr = "0" + msstr;
        if (showMs)
            return mstr + ":" + sstr + ":" + msstr;
        return mstr + ":" + sstr;
    };
    MathUtil._180_DIVIDED_BY_PI = 180 / Math.PI;
    MathUtil._PI_DIVIDED_BY_180 = Math.PI / 180;
    MathUtil._HALF_PI = Math.PI * 0.5;
    MathUtil._TWO_PI = Math.PI * 2;
    return MathUtil;
}());
exports.MathUtil = MathUtil;


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Framework_1 = __webpack_require__(0);
var AudioManager = (function (_super) {
    __extends(AudioManager, _super);
    function AudioManager() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.delayAudios = [];
        return _this;
    }
    AudioManager.prototype.stopCurrentAudio = function () {
        if (this.currentAudio) {
            this.currentAudio.stop();
            this.currentAudio = null;
        }
        this.currentAudioUrl = null;
    };
    AudioManager.prototype.stopDelayAudio = function () {
        for (var _i = 0, _a = this.delayAudios; _i < _a.length; _i++) {
            var delay = _a[_i];
            delay.disposed = true;
        }
        this.delayAudios = [];
    };
    AudioManager.prototype.playAudioAndStopOthers = function (info) {
        this.stopDelayAudio();
        this.playAndStoreAudio(info);
    };
    AudioManager.prototype.playAndStoreAudio = function (info) {
        var _this = this;
        this.stopCurrentAudio();
        this.currentAudioUrl = info.url;
        this.playAudio(info.url, info.volume).then(function (audio) {
            //console.log('on audio loaded: ' + url)
            if (_this.currentAudioUrl == info.url) {
                //console.log('audio stored');
                _this.currentAudio = audio;
                _this.currentAudio.on('end', function () {
                    if (_this.currentAudio == audio) {
                        _this.currentAudio = null;
                        if (info.url == _this.sequenceEndUrl) {
                            _this.sequenceEndUrl = null;
                            _this.emit(AudioManager.EVENT.AUDIO_COMPELTE);
                        }
                    }
                });
            }
            else {
                //console.log('cancel audio')
                audio.stop();
            }
        });
    };
    AudioManager.prototype.playAudio = function (url, vol) {
        console.log('playAudio: ' + url);
        var sound = PIXI.sound.Sound.from({ url: url });
        var audio = sound.play({ volume: vol || 1 });
        if (audio['then']) {
            return audio;
        }
        else {
            return Promise.resolve(audio);
        }
    };
    AudioManager.prototype.playAudioSequence = function (list) {
        this.stopDelayAudio();
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var info = list_1[_i];
            this.sequenceEndUrl = info.url;
            this.delayAudios.push(Framework_1.FW.addDelayFunction(this, this.playAndStoreAudio, info, info.delay));
        }
    };
    AudioManager.prototype.stopOthersAndDelayPlayAudio = function (url, delay, volume) {
        this.stopDelayAudio();
        this.stopCurrentAudio();
        this.sequenceEndUrl = url;
        this.delayAudios.push(Framework_1.FW.addDelayFunction(this, this.playAudioAndStopOthers, { url: url, volume: volume }, delay));
    };
    AudioManager.prototype.forceStopAll = function () {
        console.log('forceStopAll()');
        this.stopAll();
        this.emit(AudioManager.EVENT.AUDIO_COMPELTE);
    };
    AudioManager.prototype.stopAll = function () {
        //console.log('audio: stop all');
        this.stopDelayAudio();
        this.stopCurrentAudio();
    };
    AudioManager.prototype.playButtonInterface = function (buttonType) {
        if (!this.currentAudio) {
            return this.playAudio('assets/audio/Buttons Interface/FSO5_' + buttonType + '.mp3', 1);
        }
        return Promise.resolve(null);
    };
    AudioManager.prototype.playTipInstructions = function (list) {
        this.playAudioSequence(list.map(function (v) {
            v.url = 'assets/audio/Instructions/FSO5_Instructions_' + v.index + '.mp3';
            return v;
        }));
    };
    AudioManager.prototype.playCoverIntro = function (list) {
        this.playAudioSequence(list.map(function (v) {
            v.url = 'assets/audio/Intro/FSO5_Intro_00' + v.index + '.mp3';
            return v;
        }));
    };
    AudioManager.prototype.getWorldAudioUrl = function (worldIndex, audioIndex) {
        worldIndex++;
        var index = '' + audioIndex;
        while (index.length < 3) {
            index = '0' + index;
        }
        return 'assets/audio/World ' + worldIndex + '/FSO5_World' + worldIndex + '_' + index + '.mp3';
    };
    AudioManager.EVENT = {
        AUDIO_COMPELTE: 'audioComplete'
    };
    return AudioManager;
}(PIXI.utils.EventEmitter));
exports.AudioManager = AudioManager;
exports.audioManager = new AudioManager();


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = __webpack_require__(5);
var Framework_1 = __webpack_require__(0);
var GafManager_1 = __webpack_require__(13);
var ObjectBase_1 = __webpack_require__(12);
var BaseScreen = (function (_super) {
    __extends(BaseScreen, _super);
    function BaseScreen() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BaseScreen.prototype.setupButton = function (clip, callback, audioType) {
        if (!clip) {
            return null;
        }
        var button;
        if (clip['totalFrames']) {
            button = new GafManager_1.GafButton(clip);
        }
        else {
            button = new GafManager_1.Button(clip);
        }
        button['delayAudio'] = {};
        button['audioTime'] = 0;
        button.on(GafManager_1.GafButton.EVENT.CLICK, function () {
            if (button['audio']) {
                button['audio'].stop();
                button['audio'] = null;
            }
            button['audioTime'] = Framework_1.FW.time + 300;
            if (callback != null) {
                callback();
            }
        });
        if (audioType) {
            button.on(GafManager_1.Button.EVENT.STATE_CHANGE, function (state) {
                button['delayAudio'].disposed = true;
                if (state == GafManager_1.Button.EVENT.OVER && Framework_1.FW.time > button['audioTime']) {
                    button['delayAudio'] = Framework_1.FW.addDelayFunction(AudioManager_1.audioManager, AudioManager_1.audioManager.playButtonInterface, audioType, 1000);
                }
            });
        }
        return button;
    };
    BaseScreen.prototype.playButtonAudio = function (data) {
        AudioManager_1.audioManager.playButtonInterface(data.audioTye)
            .then(function (sound) {
            data.button['audio'] = sound;
        });
    };
    BaseScreen.prototype.setButtonEnabled = function (button, enable, addFilter) {
        if (addFilter === void 0) { addFilter = true; }
        if (!button) {
            return;
        }
        if (enable) {
            button.displayObject.interactive = true;
            button.displayObject.filters = null;
            button.displayObject.alpha = 1;
        }
        else {
            button['delayAudio'].disposed = true;
            if (addFilter) {
                var filter = new PIXI.filters.ColorMatrixFilter();
                filter.desaturate();
                button.displayObject.alpha = 0.8;
                button.displayObject.filters = [filter];
            }
            button.displayObject.interactive = false;
        }
    };
    BaseScreen.prototype.dispose = function () {
        AudioManager_1.audioManager.stopAll();
        _super.prototype.dispose.call(this);
    };
    return BaseScreen;
}(ObjectBase_1.ObjectBase));
exports.BaseScreen = BaseScreen;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var WorldInfo = (function () {
    function WorldInfo(code, index) {
        this.code = code;
        this.index = index;
        this.descriptions = [];
    }
    WorldInfo.prototype.importXML = function (_xml) {
        this.xml = _xml;
        var descs = _xml.getElementsByTagName('description');
        for (var i = 0; i < descs.length; ++i) {
            this.descriptions.push(descs[i].textContent);
        }
    };
    WorldInfo.prototype.getLevelXML = function (index) {
        var levels = this.xml.getElementsByTagName('level');
        for (var i = 0; i < levels.length; ++i) {
            var lvxml = levels[i];
            if (lvxml.getAttribute('level') == '' + index) {
                return lvxml;
            }
        }
        return null;
    };
    return WorldInfo;
}());
exports.WorldInfo = WorldInfo;
exports.WorldList = [];
function importWorldXML(xml) {
    var xmls = xml.getElementsByTagName('world');
    for (var i = 0; i < xmls.length; ++i) {
        var worldxml = xmls[i];
        var info = new WorldInfo(worldxml.getAttribute('code'), exports.WorldList.length);
        info.importXML(worldxml);
        exports.WorldList.push(info);
    }
}
exports.importWorldXML = importWorldXML;
function getWorld(code) {
    for (var _i = 0, WorldList_1 = exports.WorldList; _i < WorldList_1.length; _i++) {
        var world = WorldList_1[_i];
        if (world.code == code) {
            return world;
        }
    }
    return null;
}
exports.getWorld = getWorld;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = __webpack_require__(5);
var IntUtil_1 = __webpack_require__(32);
var WorldInfo_1 = __webpack_require__(7);
var ALL_LEVELS = {};
var COMMON_END_MESSAGES = {};
function importCommonEndMessagesXML(xml) {
    var common = xml.getElementsByTagName('common')[0];
    var endms = common.getElementsByTagName('endMessage');
    for (var i = 0; i < endms.length; ++i) {
        var list = COMMON_END_MESSAGES[endms[i].getAttribute('state')];
        if (!list) {
            list = COMMON_END_MESSAGES[endms[i].getAttribute('state')] = [];
        }
        list.push(endms[i].textContent);
    }
}
exports.importCommonEndMessagesXML = importCommonEndMessagesXML;
var LevelInfo = (function () {
    function LevelInfo(worldCode, index) {
        this.worldCode = worldCode;
        this.index = index;
        this.calls = [];
        this.instructions = [];
        this.endMessages = {};
        if (isNaN(this.index)) {
            this.index = 0;
        }
        while (this.index > 10) {
            this.index -= 11;
        }
        while (this.index < 0) {
            this.index += 11;
        }
    }
    LevelInfo.fromString = function (level) {
        if (ALL_LEVELS[level]) {
            return ALL_LEVELS[level];
        }
        var params = level.split('-');
        var info = new LevelInfo(params[1], parseInt(params[2]));
        if (info.worldCode) {
            var xml = WorldInfo_1.getWorld(info.worldCode).getLevelXML(info.index);
            if (xml) {
                ALL_LEVELS[level] = info;
                info.importXML(xml);
                return info;
            }
        }
        return null;
    };
    LevelInfo.getLevel = function (worldCode, level) {
        return LevelInfo.fromString('level-' + worldCode + '-' + level);
    };
    Object.defineProperty(LevelInfo.prototype, "worldIndex", {
        get: function () {
            return WorldInfo_1.getWorld(this.worldCode).index;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelInfo.prototype, "isChallenge", {
        get: function () {
            return this.index == 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LevelInfo.prototype, "level", {
        get: function () {
            return 'level-' + this.worldCode + '-' + (this.index ? this.index : 'challenge');
        },
        enumerable: true,
        configurable: true
    });
    LevelInfo.prototype.getNeighbor = function (dIndex) {
        return LevelInfo.fromString(new LevelInfo(this.worldCode, this.index + dIndex).level);
    };
    LevelInfo.prototype.importXML = function (_xml) {
        if (_xml) {
            var calls = _xml.getElementsByTagName('call');
            for (var i = 0; i < calls.length; ++i) {
                this.calls.push(calls[i].textContent);
            }
            var insts = _xml.getElementsByTagName('instruction');
            for (var i = 0; i < insts.length; ++i) {
                this.instructions.push(insts[i].textContent);
            }
            var endms = _xml.getElementsByTagName('endMessage');
            for (var i = 0; i < endms.length; ++i) {
                var list = this.endMessages[endms[i].getAttribute('state')];
                if (!list) {
                    list = this.endMessages[endms[i].getAttribute('state')] = [];
                }
                list.push(endms[i].textContent);
            }
        }
    };
    LevelInfo.prototype.listEndMessages = function (state) {
        var list = this.endMessages[state];
        var audio = '';
        if (!list) {
            var commonlist = COMMON_END_MESSAGES[state];
            var index = IntUtil_1.IntUtil.random(commonlist.length - 1);
            list = [commonlist[index]];
            var indexStr = '' + (index + 1);
            while (indexStr.length < 3) {
                indexStr = '0' + indexStr;
            }
            if (state == 'fail') {
                audio = 'assets/audio/Failure/FSO5_Failure_' + indexStr + '.mp3';
            }
            else if (state == 'pass') {
                audio = 'assets/audio/Success/FSO5_Success_' + indexStr + '.mp3';
            }
        }
        else if (state == 'fail') {
            audio = AudioManager_1.audioManager.getWorldAudioUrl(this.worldIndex, 36);
        }
        else if (state == 'pass') {
            audio = AudioManager_1.audioManager.getWorldAudioUrl(this.worldIndex, 32);
        }
        else if (state == 'best') {
            audio = AudioManager_1.audioManager.getWorldAudioUrl(this.worldIndex, this.isChallenge ? 35 : (1 + this.index * 3));
        }
        return { list: list, audio: audio };
    };
    return LevelInfo;
}());
exports.LevelInfo = LevelInfo;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DisplayObjectUtil = (function () {
    function DisplayObjectUtil() {
    }
    DisplayObjectUtil.removeFromParent = function (displayObj) {
        if (displayObj && displayObj.parent) {
            displayObj.parent.removeChild(displayObj);
        }
    };
    DisplayObjectUtil.setOnTopOfParent = function (displayObj) {
        if (displayObj && displayObj.parent) {
            displayObj.parent.setChildIndex(displayObj, displayObj.parent.children.length - 1);
        }
    };
    return DisplayObjectUtil;
}());
exports.DisplayObjectUtil = DisplayObjectUtil;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var NetUtil_1 = __webpack_require__(17);
var AudioManager_1 = __webpack_require__(5);
var ObjectBase_1 = __webpack_require__(12);
var Framework_1 = __webpack_require__(0);
var AppBase = (function (_super) {
    __extends(AppBase, _super);
    function AppBase() {
        var _this = _super.call(this) || this;
        window.onblur = function () {
            AudioManager_1.audioManager.forceStopAll();
        };
        return _this;
    }
    AppBase.prototype.reset = function () {
        if (this._mask && this._mask.parent) {
            this._mask.parent.removeChild(this._mask);
        }
        Framework_1.FW.incidentsManager.reset();
        ObjectBase_1.ObjectBase.cleanAll();
        Framework_1.FW.physics.reset();
        Framework_1.FW.root.removeChildren();
        if (this._mask == null) {
            this._mask = new PIXI.Graphics();
            this._mask.beginFill(0);
            this._mask.drawRect(0, 0, Framework_1.FW.stageWidth, Framework_1.FW.stageHeight);
            this._mask.endFill();
        }
        Framework_1.FW.root.addChild(this._mask);
        Framework_1.FW.root.mask = this._mask;
    };
    Object.defineProperty(AppBase, "debug", {
        get: function () {
            return NetUtil_1.NetUtil.getQueryStringValue('debug') == 'brad';
        },
        enumerable: true,
        configurable: true
    });
    return AppBase;
}(PIXI.utils.EventEmitter));
exports.AppBase = AppBase;


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Framework_1 = __webpack_require__(0);
var SoundManager = (function () {
    function SoundManager() {
        this.soundVolume = {};
    }
    SoundManager.prototype.importSoundXML = function (xml) {
        var xmls = xml.getElementsByTagName('sound');
        for (var i = 0; i < xmls.length; ++i) {
            var soundxml = xmls[i];
            var alias = soundxml.getAttribute('id');
            console.log('load sound: ' + soundxml.getAttribute('id') + ' => ' + soundxml.getAttribute('url'));
            Framework_1.FW.addPreloadResource(alias, soundxml.getAttribute('url'));
            if (soundxml.hasAttribute('vol')) {
                this.soundVolume[alias] = parseFloat(soundxml.getAttribute('vol'));
            }
        }
    };
    SoundManager.prototype.play = function (alias, loop) {
        if (loop === void 0) { loop = false; }
        return Framework_1.FW.playSound(alias, {
            loop: loop,
            volume: this.soundVolume[alias] || 1
        });
    };
    return SoundManager;
}());
exports.SoundManager = SoundManager;
exports.soundManager = new SoundManager();


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtil_1 = __webpack_require__(1);
var ObjectBase = (function (_super) {
    __extends(ObjectBase, _super);
    function ObjectBase() {
        var _this = _super.call(this) || this;
        var type = _this.objectType;
        var list = ObjectBase._objects_map[type];
        if (list == null) {
            list = ObjectBase._objects_map[type] = [];
        }
        list.push(_this);
        return _this;
    }
    ObjectBase.getObjects = function (type) {
        var list = ObjectBase._objects_map[type];
        return list || [];
    };
    ObjectBase.getObject = function (type) {
        var list = ObjectBase.getObjects(type);
        return list.length ? list[0] : null;
    };
    ObjectBase.clean = function (type) {
        var list = ObjectBase._objects_map[type].slice();
        for (var _i = 0, list_1 = list; _i < list_1.length; _i++) {
            var obj = list_1[_i];
            obj.dispose();
        }
    };
    ObjectBase.cleanAll = function () {
        var types = Object.keys(ObjectBase._objects_map);
        for (var _i = 0, types_1 = types; _i < types_1.length; _i++) {
            var type = types_1[_i];
            ObjectBase.clean(type);
        }
    };
    Object.defineProperty(ObjectBase.prototype, "objectType", {
        get: function () {
            return this.constructor.name;
        },
        enumerable: true,
        configurable: true
    });
    ObjectBase.prototype.dispose = function () {
        ArrayUtil_1.ArrayUtil.removeElement(ObjectBase.getObjects(this.objectType), this);
    };
    ObjectBase._objects_map = {};
    return ObjectBase;
}(PIXI.utils.EventEmitter));
exports.ObjectBase = ObjectBase;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var SoundManager_1 = __webpack_require__(11);
var MathUtil_1 = __webpack_require__(4);
var GafLoaderInfo = (function () {
    function GafLoaderInfo(gafName, path) {
        this.loaded = false;
        this.gafName = gafName;
        this.path = path || "";
    }
    GafLoaderInfo.prototype.getUrl = function () {
        if (this.path.charAt(this.path.length - 1) != "/") {
            this.path += "/";
        }
        return this.path + this.gafName + "/" + this.gafName + ".gaf";
    };
    return GafLoaderInfo;
}());
exports.GafLoaderInfo = GafLoaderInfo;
var GafManager = (function (_super) {
    __extends(GafManager, _super);
    function GafManager() {
        var _this = _super.call(this) || this;
        _this._gafAssetBundleMap = {};
        /*
           _gafsToLoad: gafName: GafLoaderInfo
           */
        _this._gafsToLoad = {};
        return _this;
    }
    GafManager.prototype.createMovieClip = function (gafName, linkage) {
        if (linkage === void 0) { linkage = ""; }
        var gafBundle = this._gafAssetBundleMap[gafName];
        if (gafBundle == null) {
            return null;
        }
        var gafTimeline = gafBundle.getGAFTimeline(gafName, linkage);
        if (gafTimeline == null) {
            return null;
        }
        return new GAF.GAFMovieClip(gafTimeline);
    };
    GafManager.prototype.addGafToLoad = function (gafName, path) {
        if (path === void 0) { path = null; }
        if (this._gafAssetBundleMap.hasOwnProperty(gafName) ||
            this._gafsToLoad.hasOwnProperty(gafName))
            return false;
        this._gafsToLoad[gafName] = new GafLoaderInfo(gafName, path);
        return true;
    };
    GafManager.prototype._loadGafs = function () {
        for (var gafName in this._gafsToLoad) {
            var info = this._gafsToLoad[gafName];
            if (this._loadGaf(info)) {
                return true;
            }
        }
        return false;
    };
    GafManager.prototype._loadGaf = function (info) {
        var _this = this;
        if (info.loader == null) {
            console.log('load gaf: ' + info.gafName);
            info.loader = new GAF.GAFLoader();
            info.loader.addGAFFile(info.getUrl());
            info.loader.on("complete", function () { return _this.onLoadUrls(info); });
            info.loader.on("progress", this.onGafLoaderProgress, this);
            info.loader.load();
            return true;
        }
        return false;
    };
    GafManager.prototype.loadGaf = function (gafName, path) {
        if (path === void 0) { path = null; }
        if (this.addGafToLoad(gafName, path)) {
            this._loadGafs();
            return true;
        }
        return false;
    };
    GafManager.prototype.onGafLoaderProgress = function () {
        this.emit(GafManager.EVENT.LOAD_PROGRESS, this.currentLoadedLoaders, this.currentLoadersTotal);
    };
    GafManager.prototype.onLoadUrls = function (info) {
        var _this = this;
        var converter = new GAF.ZipToGAFAssetConverter();
        converter.once(GAF.GAFEvent.COMPLETE, function (event) {
            info.loaded = true;
            _this.onGafLoaded(event);
        });
        converter.convert(info.loader);
    };
    GafManager.prototype.onGafLoaded = function (event) {
        var converter = event.target;
        var gafBundle = converter.gafBundle;
        for (var _i = 0, _a = gafBundle.get_gafAssets(); _i < _a.length; _i++) {
            var asset = _a[_i];
            this._gafAssetBundleMap[asset.get_id()] = gafBundle;
            console.log("gaf asset ready: " + asset.get_id());
        }
        /*
            if g1 and g2 start to load at the same time,
            if g1 and g2 are loaded at the same time, each onGafLoaded would have currentLoadersTotal==currentLoadedLoaders
            and caused _loadCompleteNotifier.dispatch twice.
            so we use _gafsToLoad to determine if we need to dispatch the event.
             */
        if (this.currentLoadersTotal == this.currentLoadedLoaders) {
            console.log('gaf all loaded');
            this._gafsToLoad = {};
            this.emit(GafManager.EVENT.LOAD_COMPLETE);
        }
        else {
            this._loadGafs();
        }
    };
    GafManager.prototype.isLoading = function () {
        for (var gafName in this._gafsToLoad) {
            var info = this._gafsToLoad[gafName];
            if (!info.loaded) {
                return true;
            }
        }
        return false;
    };
    Object.defineProperty(GafManager.prototype, "currentLoadersTotal", {
        get: function () {
            var count = 0;
            for (var _gafName in this._gafsToLoad) {
                ++count;
            }
            return count;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GafManager.prototype, "currentLoadedLoaders", {
        get: function () {
            var count = 0;
            for (var gafName in this._gafsToLoad) {
                var info = this._gafsToLoad[gafName];
                if (info.loaded) {
                    ++count;
                }
            }
            return count;
        },
        enumerable: true,
        configurable: true
    });
    GafManager.prototype.removeLocalTransform = function (gafObject) {
        var ltf = gafObject.transform.localTransform;
        var angle = Math.atan2(ltf.b, ltf.a);
        var denom = ltf.a * ltf.a + ltf.b * ltf.b;
        var sx = Math.sqrt(denom);
        var sy = (ltf.a * ltf.d - ltf.b * ltf.c) / sx;
        var tx = ltf.tx;
        var ty = ltf.ty;
        ltf.tx = 0;
        ltf.ty = 0;
        gafObject.transform.position.x += tx;
        gafObject.transform.position.y += ty;
        ltf.a = 1;
        ltf.b = 0;
        ltf.c = 0;
        ltf.d = 1;
        gafObject.transform.scale.x *= sx;
        gafObject.transform.scale.y *= sy;
        gafObject.rotation = MathUtil_1.MathUtil.radians2degrees(angle);
    };
    GafManager.EVENT = {
        LOAD_PROGRESS: "load-progress",
        LOAD_COMPLETE: "load-complete"
    };
    return GafManager;
}(PIXI.utils.EventEmitter));
exports.GafManager = GafManager;
/**
 * Wrap a DisplayObject to a Button utility object for easy interactive.
 */
var Button = (function (_super) {
    __extends(Button, _super);
    /**
     * constructor.
     * setup mouse event listeners, and cursor modes.
     * @param {PIXI.DisplayObject} _clip
     */
    function Button(_clip) {
        var _this = _super.call(this) || this;
        _this._clip = _clip;
        _this._isDown = false;
        _this._isOver = false;
        _this._name = "";
        _this._clip.interactive = true;
        _this._clip.buttonMode = true;
        _this._state = Button.STATE.OUT;
        _this._clip
            .on("pointerdown", _this.onButtonDown, _this)
            .on("pointerup", _this.onButtonUp, _this)
            .on("pointerupoutside", _this.onButtonUpOutside, _this)
            .on("pointerover", _this.onButtonOver, _this)
            .on("pointerout", _this.onButtonOut, _this)
            .on("touchend", _this.onTouchEnd, _this);
        return _this;
    }
    /**
     * unregister mouse event listeners.
     */
    Button.prototype.dispose = function () {
        this._clip
            .off("pointerdown", this.onButtonDown, this)
            .off("pointerup", this.onButtonUp, this)
            .off("pointerupoutside", this.onButtonUpOutside, this)
            .off("pointerover", this.onButtonOver, this)
            .off("pointerout", this.onButtonOut, this)
            .off("touchend", this.onTouchEnd, this);
    };
    Object.defineProperty(Button.prototype, "name", {
        /**
         * name of the button
         *
         * @type {string}
         */
        get: function () {
            return this._name;
        },
        set: function (value) {
            this._name = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "state", {
        /**
         * the state of the button.
         * @see Button.STATE
         * @type {string}
         */
        get: function () {
            return this._state;
        },
        set: function (value) {
            if (value != this._state) {
                //console.log('button state: ' + value);
                this._state = value;
                this.onStateChange(this._state);
            }
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.refreshState = function () {
        var state = this._state;
        if (this.isDown) {
            state = Button.STATE.DOWN;
        }
        else {
            state = this.isOver ? Button.STATE.OVER : Button.STATE.OUT;
        }
        this.state = state;
    };
    Button.prototype.onStateChange = function (state) {
        this.emit(Button.EVENT.STATE_CHANGE, state);
    };
    Object.defineProperty(Button.prototype, "displayObject", {
        get: function () {
            return this._clip;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "isDown", {
        get: function () {
            return this._isDown;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Button.prototype, "isOver", {
        get: function () {
            return this._isOver;
        },
        enumerable: true,
        configurable: true
    });
    Button.prototype.onButtonDown = function () {
        this._isDown = true;
        this._isOver = true;
        this.refreshState();
        this.emit(Button.EVENT.DOWN);
        SoundManager_1.soundManager.play('button.down');
    };
    Button.prototype.onButtonUpOutside = function () {
        this._isDown = false;
        this._isOver = false;
        this.refreshState();
        this.emit(Button.EVENT.UP_OUTSIDE);
    };
    Button.prototype.onButtonUp = function () {
        var wasdown = this._isDown;
        this._isDown = false;
        if (this._isOver) {
            this.refreshState();
            this.emit(Button.EVENT.UP);
            if (wasdown) {
                this.emit(Button.EVENT.CLICK);
            }
        }
        else {
            this.refreshState();
            this.emit(Button.EVENT.UP_OUTSIDE);
        }
    };
    Button.prototype.onButtonOver = function (_e) {
        var wasOver = this._isOver;
        this._isOver = true;
        if (this._isDown) {
            return;
        }
        this.refreshState();
        if (!wasOver) {
            if (this.displayObject.interactive) {
                this.emit(Button.EVENT.OVER);
                SoundManager_1.soundManager.play('button.over');
            }
        }
    };
    Button.prototype.onButtonOut = function () {
        this._isOver = false;
        if (this._isDown) {
            return;
        }
        this.refreshState();
        this.emit(Button.EVENT.OUT);
    };
    Button.prototype.onTouchEnd = function () {
        this.onButtonOut();
    };
    Button.EVENT = {
        CLICK: "click",
        DOWN: "down",
        UP: "up",
        UP_OUTSIDE: "upOutside",
        OVER: "over",
        OUT: "out",
        STATE_CHANGE: "stageChange"
    };
    Button.STATE = {
        DOWN: "down",
        OVER: "over",
        OUT: "out"
    };
    return Button;
}(PIXI.utils.EventEmitter));
exports.Button = Button;
/**
* Wrap a GAFMovieClip to Button utility for easy interacting.
*/
var GafButton = (function (_super) {
    __extends(GafButton, _super);
    function GafButton(gafClip) {
        var _this = _super.call(this, gafClip) || this;
        _this.gafClip = gafClip;
        _this._stateFrameMap = {};
        _this._stateFrameMap[Button.STATE.OUT] = 1;
        _this._stateFrameMap[Button.STATE.OVER] = 4;
        _this._stateFrameMap[Button.STATE.DOWN] = 3;
        _this.refreshStateFrame(_this.state);
        return _this;
    }
    GafButton.prototype.onStateChange = function (state) {
        this.refreshStateFrame(state);
        _super.prototype.onStateChange.call(this, state);
    };
    GafButton.prototype.refreshStateFrame = function (state) {
        this.gafClip.gotoAndStop(this._stateFrameMap[state]);
    };
    /**
     * Assign a frame to associate a button state
     * @param {string} state
     * @param {number} frame frame number of the movieclip
     */
    GafButton.prototype.setStateFrame = function (state, frame) {
        this._stateFrameMap[state] = frame;
        this.refreshStateFrame(state);
    };
    return GafButton;
}(Button));
exports.GafButton = GafButton;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Point = (function (_super) {
    __extends(Point, _super);
    function Point(x, y) {
        return _super.call(this, x, y) || this;
    }
    Point.distance = function (from, to) {
        var dx = to.x - from.x;
        var dy = to.y - from.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.polar = function (len, angle) {
        return new Point(Math.cos(angle) * len, Math.sin(angle) * len);
    };
    Point.fromPIXIPoint = function (point) {
        return new Point(point.x, point.y);
    };
    Point.fromXY = function (x, y) {
        return new Point(x, y);
    };
    Point.prototype.clone = function () {
        return new Point(this.x, this.y);
    };
    Point.prototype.toB2Vec2 = function () {
        return new b2Vec2(this.x, this.y);
    };
    Point.prototype.toScaledB2Vec2 = function (scale) {
        return new b2Vec2(this.x * scale, this.y * scale);
    };
    Point.prototype.toString = function () {
        return "" + this.x + "," + this.y;
    };
    Point.fromString = function (str) {
        if (str) {
            var arr = str.split(',');
            if (arr.length == 2) {
                return new Point(parseFloat(arr[0]), parseFloat(arr[1]));
            }
        }
        return null;
    };
    Point.prototype.sub = function (other) {
        return new Point(this.x - other.x, this.y - other.y);
    };
    Point.prototype.subXY = function (x, y) {
        return new Point(this.x - x, this.y - y);
    };
    Point.prototype.add = function (other) {
        return new Point(this.x + other.x, this.y + other.y);
    };
    Point.prototype.addXY = function (x, y) {
        return new Point(this.x + x, this.y + y);
    };
    Object.defineProperty(Point.prototype, "lengthSquared", {
        get: function () {
            return this.x * this.x + this.y * this.y;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Point.prototype, "length", {
        get: function () {
            return Math.sqrt(this.lengthSquared);
        },
        enumerable: true,
        configurable: true
    });
    Point.prototype.distanceTo = function (other) {
        var dx = other.x - this.x;
        var dy = other.y - this.y;
        return Math.sqrt(dx * dx + dy * dy);
    };
    Point.prototype.normalize = function (length) {
        if (length === void 0) { length = 1; }
        var len = this.length;
        if (len == 0)
            return 0;
        this.scale(length / len);
        return len;
    };
    Point.prototype.dot = function (vector) {
        return this.x * vector.x + this.y * vector.y;
    };
    Point.prototype.scale = function (value) {
        this.x *= value;
        this.y *= value;
    };
    Point.prototype.cross = function (vector) {
        var a0 = this.y * vector.x;
        var a1 = this.x * vector.y;
        return new Point(a0 - a1, a1 - a0);
    };
    Point.prototype.getNormal = function () {
        return new Point(-this.y, this.x);
    };
    Point.prototype.rotate = function (radians) {
        var cos = Math.cos(radians);
        var sin = Math.sin(radians);
        var ox = this.x;
        var oy = this.y;
        this.x = ox * cos - oy * sin;
        this.y = oy * cos + ox * sin;
    };
    return Point;
}(PIXI.Point));
exports.Point = Point;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtil_1 = __webpack_require__(1);
var Message = (function () {
    function Message(_type, _data) {
        this._date = {};
        this._type = _type;
        this._date = _data || {};
    }
    Object.defineProperty(Message.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Message.prototype, "data", {
        get: function () {
            return this._date;
        },
        enumerable: true,
        configurable: true
    });
    return Message;
}());
exports.Message = Message;
var PostPackage = (function () {
    function PostPackage(senderId, topic, message) {
        this.reset(senderId, topic, message);
    }
    PostPackage.prototype.reset = function (senderId, topic, message) {
        this._senderId = senderId;
        this._topic = topic;
        this._message = message;
        this._valid = true;
        return this;
    };
    Object.defineProperty(PostPackage.prototype, "senderId", {
        get: function () {
            return this._senderId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostPackage.prototype, "topic", {
        get: function () {
            return this._topic;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostPackage.prototype, "message", {
        get: function () {
            return this._message;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PostPackage.prototype, "valid", {
        get: function () {
            return this._valid;
        },
        enumerable: true,
        configurable: true
    });
    PostPackage.prototype.invalid = function () {
        this._valid = false;
    };
    return PostPackage;
}());
exports.PostPackage = PostPackage;
var PostClient = (function () {
    function PostClient(myTopicId, office) {
        this._topic = myTopicId;
        this._office = office;
        if (this._topic) {
            this.subscribe(this._topic);
        }
    }
    PostClient.prototype.setReceivePostFunction = function (owner, func) {
        this._onReceivePost = func;
        this._onReceivePostOwner = owner;
    };
    Object.defineProperty(PostClient.prototype, "topicId", {
        get: function () {
            return this._topic;
        },
        enumerable: true,
        configurable: true
    });
    PostClient.prototype._receivePost = function (post) {
        if (this._onReceivePost) {
            if (this._onReceivePostOwner) {
                this._onReceivePost.call(this._onReceivePostOwner, post);
            }
            else {
                this._onReceivePost(post);
            }
        }
    };
    PostClient.prototype.subscribe = function (topic) {
        this._office.subscribe(topic, this);
    };
    PostClient.prototype.unsubscribe = function (topic) {
        this._office.unsubscribe(topic, this);
    };
    PostClient.prototype.sendMessage = function (topic, message, delayMs) {
        if (delayMs === void 0) { delayMs = 0; }
        this._office.sendMessage(this._topic, topic, message, delayMs);
    };
    PostClient.prototype.dispose = function () {
        this._office.disposeClient(this);
        this._onReceivePost = null;
        this._onReceivePostOwner = null;
    };
    return PostClient;
}());
exports.PostClient = PostClient;
var PostOffice = (function () {
    function PostOffice(fw) {
        this._topicClientsMap = {};
        this._postPool = new Array();
        this._fw = fw;
    }
    PostOffice.prototype.createClient = function (clientId) {
        if (clientId === void 0) { clientId = null; }
        return new PostClient(clientId, this);
    };
    PostOffice.prototype.disposeClient = function (client) {
        for (var topic in this._topicClientsMap) {
            var clients = this._topicClientsMap[topic];
            if (ArrayUtil_1.ArrayUtil.removeElement(clients, client) && clients.length == 0) {
                delete this._topicClientsMap[topic];
            }
        }
    };
    PostOffice.prototype.subscribe = function (topic, client) {
        var clients = this._topicClientsMap[topic];
        if (clients == null) {
            clients = this._topicClientsMap[topic] = [];
        }
        ArrayUtil_1.ArrayUtil.addUniqueElement(clients, client);
    };
    PostOffice.prototype.unsubscribe = function (topic, client) {
        var clients = this._topicClientsMap[topic];
        if (clients) {
            ArrayUtil_1.ArrayUtil.removeElement(clients, client);
        }
    };
    PostOffice.prototype.sendMessage = function (senderId, topic, message, delayMs) {
        if (message === void 0) { message = null; }
        if (delayMs === void 0) { delayMs = 0; }
        if (delayMs > 0) {
            this._fw.addDelayFunction(this, this.sendPost, [this.getPost(senderId, topic, message)], delayMs);
        }
        var clients = this._topicClientsMap[topic];
        if (clients) {
            var post = this.getPost(senderId, topic, message);
            for (var _i = 0, _a = clients.slice(); _i < _a.length; _i++) {
                var client = _a[_i];
                client._receivePost(post);
                if (!post.valid)
                    break;
            }
            this.recyclePost(post);
        }
    };
    PostOffice.prototype.sendPost = function (post) {
        var clients = this._topicClientsMap[post.topic];
        if (clients) {
            for (var _i = 0, _a = clients.slice(); _i < _a.length; _i++) {
                var client = _a[_i];
                if (post.valid) {
                    client._receivePost(post);
                }
                else {
                    break;
                }
            }
        }
        this.recyclePost(post);
    };
    PostOffice.prototype.recyclePost = function (post) {
        this._postPool.push(post);
    };
    PostOffice.prototype.getPost = function (senderId, topic, message) {
        if (this._postPool.length) {
            return this._postPool.pop().reset(senderId, topic, message);
        }
        return new PostPackage(senderId, topic, message);
    };
    return PostOffice;
}());
exports.PostOffice = PostOffice;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Rectangle = (function (_super) {
    __extends(Rectangle, _super);
    function Rectangle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Rectangle.prototype.containsPoint = function (point) {
        return this.contains(point.x, point.y);
    };
    Rectangle.prototype.containsRectangle = function (other) {
        return other.x >= this.x &&
            other.y >= this.y &&
            other.right <= this.right &&
            other.bottom <= this.bottom;
    };
    Rectangle.prototype.intersects = function (other) {
        return !(other.right <= this.x ||
            other.bottom <= this.y ||
            other.x >= this.right ||
            other.y >= this.bottom);
    };
    return Rectangle;
}(PIXI.Rectangle));
exports.Rectangle = Rectangle;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var NetUtil = (function () {
    function NetUtil() {
    }
    NetUtil.getQueryStringValue = function (key) {
        return decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"));
    };
    return NetUtil;
}());
exports.NetUtil = NetUtil;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayUtil_1 = __webpack_require__(1);
var RandomGenerator = (function () {
    function RandomGenerator(seed) {
        this.seed = seed;
        this.seed = Math.abs(seed);
        if (this.seed == 0) {
            this.seed = 2147483647;
        }
        this.initSeed = this.seed;
    }
    RandomGenerator.prototype.reset = function () {
        this.seed = this.initSeed;
    };
    RandomGenerator.prototype.next = function () {
        this.seed = (this.seed * 16807) % 2147483647;
        return this.seed / 2147483647;
    };
    RandomGenerator.prototype.nextBetween = function (min, max) {
        if (min > max) {
            var temp = max;
            max = min;
            min = temp;
        }
        return min + this.next() * (max - min);
    };
    RandomGenerator.prototype.nextInt = function (max) {
        var rand = this.next();
        return Math.floor((max + 1) * rand);
    };
    RandomGenerator.prototype.nextIntBetween = function (min, max) {
        if (min > max) {
            var temp = max;
            max = min;
            min = temp;
        }
        return min + this.nextInt(max - min);
    };
    RandomGenerator.prototype.getArrayRandomElement = function (array, removeElement) {
        if (array && array.length) {
            var randomIndex = this.nextInt(array.length - 1);
            var element = array[randomIndex];
            if (removeElement)
                array.splice(randomIndex, 1);
            return element;
        }
        return null;
    };
    RandomGenerator.prototype.randomizeArray = function (array) {
        var len = array.length;
        for (var i = 0; i < len; ++i) {
            ArrayUtil_1.ArrayUtil.swapElements(array, i, this.nextInt(len - 1));
        }
    };
    RandomGenerator.prototype.generateRandomString = function (len, allowNumbers) {
        var acode = String("A").charCodeAt(0);
        var code = "";
        if (allowNumbers) {
            var index = void 0;
            while (code.length < len) {
                // 0-25: alphabet, 26-34: 1-9
                index = this.nextInt(34);
                if (index < 26) {
                    code += String.fromCharCode(acode + index);
                }
                else {
                    code += index - 25;
                }
            }
        }
        else {
            while (code.length < len) {
                code += String.fromCharCode(acode + this.nextInt(25));
            }
        }
        return code;
    };
    return RandomGenerator;
}());
exports.RandomGenerator = RandomGenerator;
var SystemRandomGenerator = (function (_super) {
    __extends(SystemRandomGenerator, _super);
    function SystemRandomGenerator() {
        return _super.call(this, 1) || this;
    }
    SystemRandomGenerator.prototype.next = function () {
        return Math.random();
    };
    return SystemRandomGenerator;
}(RandomGenerator));
exports.SystemRandomGenerator = SystemRandomGenerator;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Rectangle_1 = __webpack_require__(16);
var ScrollControl_1 = __webpack_require__(28);
var AudioManager_1 = __webpack_require__(5);
var SoundManager_1 = __webpack_require__(11);
var MathUtil_1 = __webpack_require__(4);
var LevelInfo_1 = __webpack_require__(8);
var UserRecord_1 = __webpack_require__(3);
var DisplayObjectUtil_1 = __webpack_require__(9);
var Framework_1 = __webpack_require__(0);
var BaseScreen_1 = __webpack_require__(6);
var Popup = (function (_super) {
    __extends(Popup, _super);
    function Popup() {
        var _this = _super.call(this) || this;
        _this.page = 0;
        _this.buttons = [];
        _this.tvoRequest = false;
        _this.graphics = new PIXI.Graphics();
        _this.graphics.beginFill(0x333333, 0.5);
        _this.graphics.drawRect(0, 0, Framework_1.FW.stageWidth, Framework_1.FW.stageHeight);
        _this.graphics.endFill();
        Framework_1.FW.stage.addChild(_this.graphics);
        _this.sprite = Framework_1.FW.gafManager.createMovieClip('popups', 'lib_popup');
        _this.sprite.interactive = true;
        Framework_1.FW.stage.addChild(_this.sprite);
        _this.sprite.position.set(Framework_1.FW.stageWidth / 2, Framework_1.FW.stageHeight / 2);
        return _this;
    }
    Popup.prototype.createScrollControl = function () {
        var _this = this;
        this.scrollControl = new ScrollControl_1.ScrollControl(new Rectangle_1.Rectangle(-190, -105, 255, 218));
        this.sprite.addChild(this.scrollControl);
        Framework_1.FW.gafManager.removeLocalTransform(this.sprite['scrollButton']);
        this.scrollControl.initScrollButton(this.sprite['scrollButton'], -105, 73);
        this.scrollControl.setScrollRange(-this.sprite['field'].height + 190, 0, 0);
        this.scrollControl.scrollNode.addChild(this.sprite['field']);
        if (this.sprite['field'].height > this.scrollControl.hitArea['height']) {
            this.scrollControl.start();
            Framework_1.FW.addUpdateFunction(this, this.autoScrollUpdate);
            this.autoScrollStartTime = Framework_1.FW.time + 5000;
            this.scrollControl.on(ScrollControl_1.ScrollControl.EVENT.SCROLL_START, function () {
                Framework_1.FW.removeUpdateFunction(_this, _this.autoScrollUpdate);
            });
        }
        else {
            this.scrollControl.interactive = false;
            this.sprite['scrollButton'].visible = false;
        }
    };
    Popup.prototype.autoScrollUpdate = function (dt) {
        if (Framework_1.FW.time < this.autoScrollStartTime) {
            return;
        }
        if (this.scrollControl.currentScroll <= this.scrollControl.scrollRange.min) {
            Framework_1.FW.removeUpdateFunction(this, this.autoScrollUpdate);
        }
        else {
            this.scrollControl.setCurrentScroll(this.scrollControl.currentScroll - dt * 0.008, true);
        }
    };
    Popup.prototype.setupButton = function (clip, callback, audioType) {
        var button = _super.prototype.setupButton.call(this, clip, callback, audioType);
        if (button) {
            this.buttons.push(button);
        }
        return button;
    };
    Popup.prototype.setTheme = function (worldCode) {
        this.sprite['bg'].gotoAndStop(worldCode);
        this.sprite['decoration'].gotoAndStop(worldCode);
    };
    Popup.prototype.dispose = function () {
        if (this.scrollControl) {
            this.scrollControl.dispose();
        }
        Framework_1.FW.removeUpdateFunction(this, this.autoScrollUpdate);
        DisplayObjectUtil_1.DisplayObjectUtil.removeFromParent(this.sprite);
        DisplayObjectUtil_1.DisplayObjectUtil.removeFromParent(this.graphics);
    };
    Popup.prototype.basicSetup = function (worldCode, level, frame, delay, resolve, resolveBack) {
        var _this = this;
        this.sprite.gotoAndStop(frame);
        this.setTheme(worldCode);
        this.sprite['decoration'].visible = frame != 4;
        this.graphics.interactive = true;
        if (level) {
            this.sprite['level'].gotoAndStop(level.isChallenge ? 11 : level.index);
        }
        else {
            Framework_1.FW.gafManager.removeLocalTransform(this.sprite['decoration']);
            this.sprite['decoration'].y -= 24;
            this.sprite['level'].visible = false;
        }
        if (resolveBack) {
            this.setupButton(this.sprite['mButtonBack'], function () {
                _this.close(function () {
                    resolve('back');
                });
            }, 'Back');
        }
        else {
            this.graphics.on('pointerdown', function (_event) {
                _this.close(function () {
                    resolve();
                }, 250);
            });
            this.setupButton(this.sprite['mButtonBack'], function () {
                _this.close(function () {
                    resolve();
                }, 250);
            }, 'Back');
        }
        this.sprite.scale.set(0.1, 0.1);
        var tween = new TWEEN.Tween(this.sprite.scale);
        tween.to({ "x": 1, "y": 1 }, 1000).easing(TWEEN.Easing.Elastic.Out);
        if (delay) {
            this.graphics.alpha = 0;
            this.sprite.visible = false;
            Framework_1.FW.addDelayFunction(null, function () {
                _this.graphics.alpha = 1;
                _this.sprite.visible = true;
                tween.start();
            }, null, delay);
        }
        else {
            tween.start();
        }
        Framework_1.FW.addDelayFunction(null, function () {
            _this.createScrollControl();
        }, null, 10);
    };
    Popup.prototype.setText = function (text) {
        var field = this.sprite['field'];
        field['textField'].style.lineHeight = 20;
        this.sprite['field'].set_text(' ' + text);
    };
    Popup.prototype.forWorldSelect = function (world) {
        var _this = this;
        return new Promise(function (resolve) {
            _this.basicSetup(world.code, null, 1, 0, resolve, false);
            _this.sprite['buttonPlay'].visible = false;
            var button = _this.setupButton(_this.sprite['buttonContinue'], function () {
                _this.close(function () {
                    resolve(world.code);
                });
            }, 'Play');
            var audio = AudioManager_1.audioManager.getWorldAudioUrl(world.index, 1);
            AudioManager_1.audioManager.stopOthersAndDelayPlayAudio(audio, 1200);
            if (!UserRecord_1.userRecord.isAudioPlayed(audio)) {
                _this.setButtonEnabled(button, false);
                AudioManager_1.audioManager.on(AudioManager_1.AudioManager.EVENT.AUDIO_COMPELTE, function () {
                    UserRecord_1.userRecord.setAudioPlayed(audio);
                    _this.setButtonEnabled(button, true);
                });
            }
            _this.setupTextsPages(world.descriptions);
        });
    };
    Popup.prototype.forLevelSelect = function (level) {
        var _this = this;
        return new Promise(function (resolve) {
            var info = LevelInfo_1.LevelInfo.fromString(level);
            _this.basicSetup(info.worldCode, info, 1, 0, resolve, false);
            _this.sprite.pivot.set(_this.sprite.width / 2, _this.sprite.height / 2);
            _this.sprite['buttonPlay'].visible = false;
            var button = _this.setupButton(_this.sprite['buttonContinue'], function () {
                _this.close(function () {
                    resolve(level);
                });
            }, 'Play');
            var audio = AudioManager_1.audioManager.getWorldAudioUrl(info.worldIndex, info.isChallenge ? 33 : info.index * 3 - 1);
            AudioManager_1.audioManager.stopOthersAndDelayPlayAudio(audio, 1200);
            if (_this.tvoRequest && !UserRecord_1.userRecord.isAudioPlayed(audio)) {
                _this.setButtonEnabled(button, false);
                AudioManager_1.audioManager.on(AudioManager_1.AudioManager.EVENT.AUDIO_COMPELTE, function () {
                    UserRecord_1.userRecord.setAudioPlayed(audio);
                    _this.setButtonEnabled(button, true);
                });
            }
            _this.setupTextsPages(info.calls);
        });
    };
    Popup.prototype.forLevelInstructions = function (level) {
        var _this = this;
        return new Promise(function (resolve) {
            console.log('forLevelInstructions: ' + level);
            var info = LevelInfo_1.LevelInfo.fromString(level);
            _this.basicSetup(info.worldCode, info, 1, 0, resolve, true);
            _this.sprite.pivot.set(_this.sprite.width / 2, _this.sprite.height / 2);
            _this.sprite['buttonContinue'].visible = false;
            var button = _this.setupButton(_this.sprite['buttonPlay'], function () {
                _this.close(function () {
                    resolve(level);
                });
            }, 'Play');
            var audio = AudioManager_1.audioManager.getWorldAudioUrl(info.worldIndex, info.isChallenge ? 34 : info.index * 3);
            AudioManager_1.audioManager.stopOthersAndDelayPlayAudio(audio, 1200);
            if (_this.tvoRequest && !UserRecord_1.userRecord.isAudioPlayed(audio)) {
                _this.setButtonEnabled(button, false);
                AudioManager_1.audioManager.on(AudioManager_1.AudioManager.EVENT.AUDIO_COMPELTE, function () {
                    UserRecord_1.userRecord.setAudioPlayed(audio);
                    _this.setButtonEnabled(button, true);
                });
            }
            _this.setupTextsPages(info.instructions);
        });
    };
    Popup.prototype.setupTexts = function (texts, page, buttonPrev, buttonNext) {
        var totalPages = texts.length;
        this.page = Math.max(0, Math.min(totalPages - 1, page));
        //texts = texts.concat(texts).concat(texts);
        //this.setText(texts[this.page].replace(/\\n/g, '\n'));
        //buttonPrev.displayObject.visible = this.page > 0;
        //buttonNext.displayObject.visible = totalPages && this.page < totalPages - 1;
        var txt = texts.join('\n\n').replace(/\\n/g, '\n');
        this.setText(txt);
        buttonPrev.displayObject.visible = false;
        buttonNext.displayObject.visible = false;
    };
    Popup.prototype.setupTextsPages = function (texts) {
        var _this = this;
        var buttonPrev = this.setupButton(this.sprite['buttonPrev'], function () {
            _this.setupTexts(texts, _this.page - 1, buttonPrev, buttonNext);
        }, 'Previous');
        var buttonNext = this.setupButton(this.sprite['buttonNext'], function () {
            _this.setupTexts(texts, _this.page + 1, buttonPrev, buttonNext);
        }, 'Next');
        this.setupTexts(texts, 0, buttonPrev, buttonNext);
    };
    Popup.prototype.close = function (cb, duration) {
        var _this = this;
        if (duration === void 0) { duration = 500; }
        for (var _i = 0, _a = this.buttons; _i < _a.length; _i++) {
            var button = _a[_i];
            this.setButtonEnabled(button, false, false);
        }
        this.sprite.interactive = false;
        this.sprite.interactiveChildren = false;
        AudioManager_1.audioManager.stopAll();
        var tween = new TWEEN.Tween(this.sprite.scale);
        tween.to({ "x": 0.2, "y": 0.2 }, duration).easing(TWEEN.Easing.Back.In);
        tween.onComplete(function () {
            _this.dispose();
            cb();
        });
        tween.start();
    };
    Popup.prototype.forLevelFailed = function (level) {
        var _this = this;
        return new Promise(function (resolve) {
            var info = LevelInfo_1.LevelInfo.fromString(level);
            _this.basicSetup(info.worldCode, info, 2, 1000, resolve, true);
            Framework_1.FW.addDelayFunction(null, function () { return SoundManager_1.soundManager.play('level.fail'); }, null, 1000);
            _this.sprite.pivot.set(_this.sprite.width / 2, _this.sprite.height / 2);
            _this.setupButton(_this.sprite['buttonAgain'], function () {
                _this.close(function () {
                    resolve(level);
                });
            }, 'Retry');
            var message = info.listEndMessages('fail');
            _this.setupTextsPages(message.list);
            AudioManager_1.audioManager.stopOthersAndDelayPlayAudio(message.audio, 2000);
        });
    };
    Popup.prototype.forLevelComplete = function (record) {
        var _this = this;
        return new Promise(function (resolve) {
            var level = LevelInfo_1.LevelInfo.fromString(record.level);
            _this.basicSetup(level.worldCode, level, 4, 0, resolve, true);
            SoundManager_1.soundManager.play('level.complete');
            _this.sprite.pivot.set(_this.sprite.width / 2, _this.sprite.height / 2);
            if (record.stars) {
                _this.sprite['stars'].gotoAndStop(record.stars + 1);
            }
            else {
                _this.sprite['stars'].gotoAndStop(1);
            }
            _this.sprite['time'].set_text(MathUtil_1.MathUtil.formatTimer(record.time, false));
            Framework_1.FW.gafManager.removeLocalTransform(_this.sprite['time']);
            _this.sprite['time'].y += 12;
            var buttonContinue = _this.setupButton(_this.sprite['buttonNextLevel'], function () {
                _this.close(function () {
                    if (level.isChallenge) {
                        resolve('worlds');
                    }
                    else {
                        resolve(level.getNeighbor(1).level);
                    }
                });
            }, 'Continue');
            if (record.stars < 3) {
                _this.setupButton(_this.sprite['buttonReplay'], function () {
                    _this.close(function () {
                        resolve(record.level);
                    });
                }, 'PlayAgain');
            }
            else {
                _this.sprite['buttonReplay'].visible = false;
            }
            var message = level.listEndMessages(record.stars < 3 ? 'pass' : 'best');
            _this.setupTextsPages(message.list);
            AudioManager_1.audioManager.stopOthersAndDelayPlayAudio(message.audio, 2000);
            if (_this.tvoRequest && level.isChallenge && !UserRecord_1.userRecord.isAudioPlayed(message.audio)) {
                _this.setButtonEnabled(buttonContinue, false);
                AudioManager_1.audioManager.on(AudioManager_1.AudioManager.EVENT.AUDIO_COMPELTE, function () {
                    UserRecord_1.userRecord.setAudioPlayed(message.audio);
                    _this.setButtonEnabled(buttonContinue, true);
                });
            }
        });
    };
    return Popup;
}(BaseScreen_1.BaseScreen));
exports.Popup = Popup;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var app_world_1 = __webpack_require__(2);
var Framework_1 = __webpack_require__(0);
var BaseScreen_1 = __webpack_require__(6);
var AboutScreen = (function (_super) {
    __extends(AboutScreen, _super);
    function AboutScreen() {
        var _this = _super.call(this) || this;
        _this._sprite = Framework_1.FW.gafManager.createMovieClip('worlds', 'lib_about_screen');
        Framework_1.FW.root.addChild(_this._sprite);
        _this.setupButton(_this._sprite['buttonBack'], function () {
            app_world_1.app.showCover();
        }, 'Back');
        return _this;
    }
    Object.defineProperty(AboutScreen.prototype, "sprite", {
        get: function () {
            return this._sprite;
        },
        enumerable: true,
        configurable: true
    });
    return AboutScreen;
}(BaseScreen_1.BaseScreen));
exports.AboutScreen = AboutScreen;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WorldInfo_1 = __webpack_require__(7);
var UserRecord_1 = __webpack_require__(3);
var Popup_1 = __webpack_require__(19);
var app_world_1 = __webpack_require__(2);
var Framework_1 = __webpack_require__(0);
var BaseScreen_1 = __webpack_require__(6);
var GameCover = (function (_super) {
    __extends(GameCover, _super);
    function GameCover() {
        var _this = _super.call(this) || this;
        _this._sprite = Framework_1.FW.gafManager.createMovieClip('worlds', 'lib_worlds_cover');
        Framework_1.FW.root.addChild(_this._sprite);
        for (var _i = 0, WorldList_1 = WorldInfo_1.WorldList; _i < WorldList_1.length; _i++) {
            var world = WorldList_1[_i];
            _this.setupWorldButton(world);
        }
        _this.setupButton(_this._sprite['buttonBack'], function () {
            app_world_1.app.showCover();
        }, 'Back');
        return _this;
    }
    Object.defineProperty(GameCover.prototype, "sprite", {
        get: function () {
            return this._sprite;
        },
        enumerable: true,
        configurable: true
    });
    GameCover.prototype.setupWorldButton = function (world) {
        var clip = this._sprite[world.code];
        if (UserRecord_1.userRecord.isWorldLocked(world.code)) {
            clip.gotoAndStop('locked');
        }
        else {
            clip.gotoAndStop(world.code);
            var progress = Math.round(UserRecord_1.userRecord.getWorldProgress(world.code) * 100);
            clip['progress']['field'].y += 12;
            clip['progress']['field'].set_text('' + progress + '%');
            this.setupButton(clip['buttonPlay'], function () {
                new Popup_1.Popup().forWorldSelect(world)
                    .then(function (wcode) { return app_world_1.app.enterWorld(wcode); });
            }, 'Play');
        }
    };
    return GameCover;
}(BaseScreen_1.BaseScreen));
exports.GameCover = GameCover;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Color_1 = __webpack_require__(25);
var MathUtil_1 = __webpack_require__(4);
var app_world_1 = __webpack_require__(2);
var LevelInfo_1 = __webpack_require__(8);
var UserRecord_1 = __webpack_require__(3);
var GameHost_1 = __webpack_require__(34);
var Popup_1 = __webpack_require__(19);
var BaseScreen_1 = __webpack_require__(6);
var Framework_1 = __webpack_require__(0);
var LevelSelectScreen = (function (_super) {
    __extends(LevelSelectScreen, _super);
    function LevelSelectScreen(config) {
        var _this = _super.call(this) || this;
        _this.config = config;
        _this._sprite = Framework_1.FW.gafManager.createMovieClip('worlds', 'lib_level_selection');
        _this._sprite.gotoAndStop(_this.config.code);
        Framework_1.FW.root.addChild(_this._sprite);
        var field = _this._sprite['title'];
        //field.set_text(this.config.code);
        field.set_text('');
        _this.refreshLevelClips();
        UserRecord_1.userRecord.on(UserRecord_1.UserRecord.EVENT.LEVEL_RECORD_CHANGE, function () {
            _this.refreshLevelClips();
        });
        _this.setupButton(_this._sprite['buttonBack'], function () {
            app_world_1.app.showGameCover();
        }, 'Back');
        return _this;
    }
    LevelSelectScreen.prototype.refreshLevelClips = function () {
        for (var lv = 0; lv <= 10; ++lv) {
            this.setupLevelClip(lv);
        }
    };
    Object.defineProperty(LevelSelectScreen.prototype, "sprite", {
        get: function () {
            return this._sprite;
        },
        enumerable: true,
        configurable: true
    });
    LevelSelectScreen.prototype.setupLevelClip = function (lvIndex) {
        var _this = this;
        var clipname = lvIndex == 0 ? 'levelchallenge' : ('level' + lvIndex);
        var info = LevelInfo_1.LevelInfo.getLevel(this.config.code, lvIndex);
        var level = info.level;
        var clip = this._sprite[clipname];
        var timeName = 'time_' + this.config.code;
        var levelName = 'level_' + this.config.code;
        if (UserRecord_1.userRecord.isLevelLocked(level)) {
            levelName += '_locked';
            clip.gotoAndStop(this.config.code + '_locked');
            var color = new Color_1.Color(0);
            var filter = new PIXI.filters.ColorMatrixFilter();
            filter.matrix = color.tintMatrix(0.5);
            clip.filters = [filter];
        }
        else {
            clip.gotoAndStop(this.config.code);
            clip.filters = [];
        }
        if (clip.name.indexOf('inited') == -1) {
            Framework_1.FW.gafManager.removeLocalTransform(clip[levelName]);
            clip[levelName].x -= 7;
            clip[levelName].y += 7;
            clip[levelName].set_text('' + lvIndex);
        }
        if (info.isChallenge) {
            clip[levelName].visible = false;
            clip['challenge_icon'].visible = true;
        }
        else {
            clip[levelName].visible = true;
            clip['challenge_icon'].visible = false;
        }
        if (UserRecord_1.userRecord.isLevelLocked(level)) {
        }
        else {
            if (clip.name.indexOf('inited') == -1) {
                Framework_1.FW.gafManager.removeLocalTransform(clip[timeName]);
                if (lvIndex == 0) {
                    clip[timeName].x -= 42;
                    clip[timeName].y += 15;
                }
                else {
                    clip[timeName].x -= 7;
                    clip[timeName].y += 7;
                }
                this.setupButton(clip['buttonPlay'], function () { return _this.showLevel(level); }, 'Play');
            }
            clip.name += 'inited';
            var record = UserRecord_1.userRecord.getLevelRecord(level);
            var stars = clip['stars'];
            if (record && record.stars) {
                stars.gotoAndStop(record.stars + 1);
            }
            else {
                stars.gotoAndStop(1);
            }
            if (record) {
                clip[timeName].set_text(MathUtil_1.MathUtil.formatTimer(record.time, false));
            }
            else {
                clip[timeName].set_text(' -:--');
            }
        }
    };
    LevelSelectScreen.prototype.showLevel = function (level) {
        var _this = this;
        if (level == 'worlds') {
            app_world_1.app.showGameCover();
        }
        else if (level && LevelInfo_1.LevelInfo.fromString(level)) {
            new Popup_1.Popup().forLevelSelect(level)
                .then(function (lv) { return _this.playLevel(lv); });
        }
    };
    LevelSelectScreen.prototype.playLevel = function (level) {
        var _this = this;
        if (level) {
            new GameHost_1.GameHost(level).execute()
                .then(function (nextLevel) { return _this.showLevel(nextLevel); });
        }
    };
    return LevelSelectScreen;
}(BaseScreen_1.BaseScreen));
exports.LevelSelectScreen = LevelSelectScreen;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var AudioManager_1 = __webpack_require__(5);
var app_world_1 = __webpack_require__(2);
var Framework_1 = __webpack_require__(0);
var BaseScreen_1 = __webpack_require__(6);
var MainCover = (function (_super) {
    __extends(MainCover, _super);
    function MainCover() {
        var _this = _super.call(this) || this;
        $('.kidsafe').css('display', 'block');
        _this._sprite = Framework_1.FW.gafManager.createMovieClip('worlds', 'lib_main_cover');
        Framework_1.FW.root.addChild(_this._sprite);
        _this.setupButton(_this._sprite['buttonPlay'], function () {
            app_world_1.app.showGameCover();
            AudioManager_1.audioManager.playCoverIntro([
                { index: 1, delay: 0 },
                { index: 2, delay: 8000 }
            ]);
        }, 'Play');
        _this.setupButton(_this._sprite['buttonAbout'], function () {
            app_world_1.app.showAbout();
        }, 'About');
        var isan = new PIXI.Text('ISAN# 0000-0004-EA31-0000-E-0000-0000-W', {
            fill: 0xFFFFFF,
            fontSize: 10,
            dropShadow: true,
            dropShadowDistance: 0.3,
            dropShadowBlur: 3
        });
        _this._sprite.addChild(isan);
        isan.position.set((Framework_1.FW.stageWidth - isan.width) / 2 + 6, Framework_1.FW.stageHeight - 18);
        return _this;
    }
    Object.defineProperty(MainCover.prototype, "sprite", {
        get: function () {
            return this._sprite;
        },
        enumerable: true,
        configurable: true
    });
    MainCover.prototype.dispose = function () {
        $('.kidsafe').css('display', 'none');
        _super.prototype.dispose.call(this);
    };
    return MainCover;
}(BaseScreen_1.BaseScreen));
exports.MainCover = MainCover;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var GameTopic = (function () {
    function GameTopic() {
    }
    GameTopic.GAME_START = 'GAME_START';
    GameTopic.LEVEL_RESET = 'LEVEL_RESET';
    GameTopic.LEVEL_END = 'LEVEL_END';
    GameTopic.INSTRUCTION_CLOSE = 'INSTRUCTION_CLOSE';
    GameTopic.INVENTORY_IN_POSITION = 'INVENTORY_IN_POSITION';
    GameTopic.INVENTORY_ANIMATION_DONE = 'INVENTORY_ANIMATION_DONE';
    GameTopic.CONTACT = 'CONTACT';
    GameTopic.SWITCH = 'SWITCH';
    return GameTopic;
}());
exports.GameTopic = GameTopic;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Color = (function () {
    function Color(color, alpha) {
        if (color === void 0) { color = 0; }
        if (alpha === void 0) { alpha = 1; }
        this.color = color;
        this.alpha = alpha;
    }
    Object.defineProperty(Color.prototype, "red", {
        get: function () {
            return this.color >> 16;
        },
        set: function (value) {
            this.color = (this.color & 0xFFFF) | (value & 0xFF) << 16;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "green", {
        get: function () {
            return (this.color & 0xFF00) >> 8;
        },
        set: function (value) {
            this.color = (this.color & 0xFF00FF) | (value & 0xFF) << 8;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Color.prototype, "blue", {
        get: function () {
            return this.color & 0xFF;
        },
        set: function (value) {
            this.color = (this.color & 0xFFFF00) | (value & 0xFF);
        },
        enumerable: true,
        configurable: true
    });
    Color.prototype.setRGB = function (red, green, blue) {
        this.color = (red & 0xFF) << 16 | (green & 0xFF) << 8 | (blue & 0xFF);
    };
    Color.prototype.clone = function () {
        return new Color(this.color, this.alpha);
    };
    Color.prototype.safeScaledByte = function (value, scale) {
        return Math.min(0xFF, Math.max(0, value * scale));
    };
    Color.prototype.mix = function (red, green, blue, percent) {
        var invertPercent = 1 - percent;
        this.setRGB(this.safeScaledByte(this.red, invertPercent) + this.safeScaledByte(red, percent), this.safeScaledByte(this.green, invertPercent) + this.safeScaledByte(green, percent), this.safeScaledByte(this.blue, invertPercent) + this.safeScaledByte(blue, percent));
    };
    Color.prototype.tintMatrix = function (percent) {
        var rpercent = 1 - percent;
        return [
            rpercent, 0, 0, 0, this.red * percent,
            0, rpercent, 0, 0, this.green * percent,
            0, 0, rpercent, 0, this.blue * percent,
            0, 0, 0, this.alpha, 0,
        ];
    };
    return Color;
}());
exports.Color = Color;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Framework_1 = __webpack_require__(0);
var IncidentElementBase = (function () {
    function IncidentElementBase(params) {
        this._params = params || {};
    }
    IncidentElementBase.prototype.dispose = function () {
    };
    return IncidentElementBase;
}());
exports.IncidentElementBase = IncidentElementBase;
var CheckBase = (function (_super) {
    __extends(CheckBase, _super);
    function CheckBase(params) {
        if (params === void 0) { params = null; }
        var _this = _super.call(this, params) || this;
        _this._enabled = true;
        return _this;
    }
    CheckBase.prototype.checkPass = function () {
        return true;
    };
    Object.defineProperty(CheckBase.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        set: function (value) {
            this._enabled = value;
        },
        enumerable: true,
        configurable: true
    });
    CheckBase.prototype.onIncidentRestart = function () {
        this.enabled = true;
    };
    return CheckBase;
}(IncidentElementBase));
exports.CheckBase = CheckBase;
var TriggerBase = (function (_super) {
    __extends(TriggerBase, _super);
    function TriggerBase(params) {
        if (params === void 0) { params = null; }
        var _this = _super.call(this, params) || this;
        _this._postClient = Framework_1.FW.postOffice.createClient();
        _this._postClient.setReceivePostFunction(_this, _this._onReceivePost);
        return _this;
    }
    TriggerBase.prototype._onReceivePost = function (_post) {
    };
    TriggerBase.prototype.dispose = function () {
        this._postClient.dispose();
    };
    TriggerBase.prototype.checkPass = function () {
        return false;
    };
    TriggerBase.prototype.checkAndTriggerIncident = function () {
        if (this.incident.runChecks(this)) {
            this.incident.trigger();
            return true;
        }
        return false;
    };
    return TriggerBase;
}(CheckBase));
exports.TriggerBase = TriggerBase;
var ActionBase = (function (_super) {
    __extends(ActionBase, _super);
    function ActionBase(params) {
        if (params === void 0) { params = null; }
        return _super.call(this, params) || this;
    }
    ActionBase.prototype.execute = function () { };
    ;
    return ActionBase;
}(IncidentElementBase));
exports.ActionBase = ActionBase;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RandomGenerator_1 = __webpack_require__(18);
var IncidentElements_1 = __webpack_require__(26);
var PostOffice_1 = __webpack_require__(15);
var ArrayUtil_1 = __webpack_require__(1);
var Incident = (function () {
    function Incident(manager, id, _params) {
        this._params = _params;
        this._id = "";
        this._checks = new Array();
        this._actions = new Array();
        this._timeToCheck = 0;
        this._enabled = true;
        this._repeats = 0;
        this._repeatInterval = 1;
        this._checkInterval = 100;
        if (typeof id !== "string" || !id) {
            throw new Error("incident must have a valid id");
        }
        this._manager = manager;
        this._id = id;
        if (this._params.hasOwnProperty("checkInterval")) {
            this._checkInterval = this._params.checkInterval;
        }
        if (this._params.hasOwnProperty("repeats")) {
            this._repeats = this._params.repeats;
        }
        if (this._params.hasOwnProperty("repeatInterval")) {
            this._repeatInterval = this._params.repeatInterval;
        }
    }
    Object.defineProperty(Incident, "TOPIC_TRIGGERED", {
        get: function () {
            return "incidentTriggered";
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Incident.prototype, "checkInterval", {
        get: function () {
            return this._checkInterval;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Incident.prototype, "manager", {
        get: function () {
            return this._manager;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Incident.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Incident.prototype, "enabled", {
        get: function () {
            return this._enabled;
        },
        enumerable: true,
        configurable: true
    });
    Incident.prototype.addCheck = function (check) {
        check.incident = this;
        this._checks.push(check);
        return this;
    };
    Incident.prototype.addAction = function (action) {
        action.incident = this;
        this._actions.push(action);
        return this;
    };
    Incident.prototype.hasTriggers = function () {
        for (var _i = 0, _a = this._checks; _i < _a.length; _i++) {
            var check = _a[_i];
            if (check instanceof IncidentElements_1.TriggerBase) {
                return true;
            }
        }
        return false;
    };
    Incident.prototype.runChecks = function (ignoreCheck) {
        if (ignoreCheck === void 0) { ignoreCheck = null; }
        for (var _i = 0, _a = this._checks; _i < _a.length; _i++) {
            var check = _a[_i];
            if (check.enabled && ignoreCheck != check && !check.checkPass())
                return false;
        }
        return true;
    };
    Incident.prototype.trigger = function () {
        console.log("trigger: " + this.id);
        for (var _i = 0, _a = this._actions; _i < _a.length; _i++) {
            var action = _a[_i];
            action.execute();
        }
        this.disable();
        this._manager.fw.postOffice.sendMessage(this.id, Incident.TOPIC_TRIGGERED, new PostOffice_1.Message(Incident.TOPIC_TRIGGERED, {
            incident: this
        }));
        this.removeOrRepeat();
    };
    Incident.prototype.removeOrRepeat = function () {
        if (this._repeats > 0) {
            console.log("repeat: " + this.id);
            --this._repeats;
            for (var _i = 0, _a = this._checks; _i < _a.length; _i++) {
                var check = _a[_i];
                check.onIncidentRestart();
            }
            this.enable(this._manager.fw.time + this._repeatInterval);
        }
        else {
            this.dispose();
        }
    };
    Incident.prototype.dispose = function () {
        this.disable();
        this._manager.removeIncident(this);
        for (var _i = 0, _a = this._actions; _i < _a.length; _i++) {
            var action = _a[_i];
            action.dispose();
        }
        for (var _b = 0, _c = this._checks; _b < _c.length; _b++) {
            var check = _c[_b];
            check.dispose();
        }
    };
    Object.defineProperty(Incident.prototype, "timeToCheck", {
        get: function () {
            return this._timeToCheck;
        },
        enumerable: true,
        configurable: true
    });
    Incident.prototype.disable = function () {
        this._enabled = false;
    };
    Incident.prototype.enable = function (timeToStartCheck) {
        this._timeToCheck = timeToStartCheck;
        this._enabled = true;
        this._manager._addIncident(this);
    };
    return Incident;
}());
exports.Incident = Incident;
var IncidentManager = (function () {
    function IncidentManager(fw) {
        this._incidentMap = {};
        this.data = {};
        this.fw = fw;
    }
    IncidentManager.prototype.parseString = function (str) {
        while (true) {
            var end = str.indexOf("}");
            if (end == -1)
                break;
            var start = str.lastIndexOf("{", end);
            if (start == -1)
                break;
            var subkey = str.substr(start, end - start + 1);
            var foundkey = this.getData(subkey.substr(1, subkey.length - 2));
            if (foundkey) {
                foundkey = foundkey.replace(/{/g, "");
                foundkey = foundkey.replace(/}/g, "");
            }
            else {
                foundkey = "";
            }
            str = str.replace(subkey, foundkey);
        }
        return str;
    };
    IncidentManager.prototype.setData = function (key, value) {
        this.data[key] = value;
    };
    IncidentManager.prototype.getData = function (key) {
        return this.data[key];
    };
    IncidentManager.prototype.reset = function () {
        for (var incidentId in this._incidentMap) {
            this._incidentMap[incidentId].dispose();
        }
        this._incidentMap = {};
        this._incidents_needCheck = null;
        this.fw.removeUpdateFunction(this, this.update);
    };
    IncidentManager.prototype.createIncident = function (id, params) {
        if (params === void 0) { params = null; }
        id = id || new RandomGenerator_1.SystemRandomGenerator().generateRandomString(10);
        var incident = new Incident(this, id, params);
        this._addIncident(incident);
        return incident;
    };
    IncidentManager.prototype.isStarted = function () {
        return this._incidents_needCheck != null;
    };
    IncidentManager.prototype.getincident = function (id) {
        return this._incidentMap[id];
    };
    IncidentManager.prototype._addIncident = function (incident) {
        if (this._incidentMap.hasOwnProperty(incident.id) &&
            this._incidentMap[incident.id] != incident) {
            throw new Error("Error: incident id already exist:" + incident.id);
        }
        this._incidentMap[incident.id] = incident;
        if (this.isStarted()) {
            if (incident.hasTriggers()) {
                ArrayUtil_1.ArrayUtil.removeElement(this._incidents_needCheck, incident);
            }
            else {
                ArrayUtil_1.ArrayUtil.addUniqueElement(this._incidents_needCheck, incident);
                ArrayUtil_1.ArrayUtil.sortNumericOn(this._incidents_needCheck, "timeToCheck", true);
            }
        }
    };
    IncidentManager.prototype.removeIncident = function (incident) {
        ArrayUtil_1.ArrayUtil.removeElement(this._incidents_needCheck, incident);
    };
    IncidentManager.prototype.start = function () {
        this._incidents_needCheck = new Array();
        for (var id in this._incidentMap) {
            var incident = this.getincident(id);
            if (!incident.hasTriggers()) {
                this._incidents_needCheck.push(incident);
            }
        }
        ArrayUtil_1.ArrayUtil.sortNumericOn(this._incidents_needCheck, "timeToCheck", true);
        this.fw.addUpdateFunction(this, this.update);
    };
    IncidentManager.prototype.update = function () {
        if (this._incidents_needCheck.length) {
            var now = this.fw.time;
            var forceEndTime = new Date().getTime() + 10; // 10 ms max for one frame
            var incident = this._incidents_needCheck[0];
            if (this.checkAndTriggerIncident(now, incident) &&
                this._incidents_needCheck.length) {
                var checkedincidents = [incident];
                incident = this._incidents_needCheck[0];
                while (checkedincidents.indexOf(incident) == -1) {
                    if (!this.checkAndTriggerIncident(now, incident) ||
                        this._incidents_needCheck.length == 0 ||
                        new Date().getTime() > forceEndTime) {
                        break;
                    }
                    incident = this._incidents_needCheck[0];
                }
            }
        }
    };
    IncidentManager.prototype.checkAndTriggerIncident = function (now, incident) {
        if (now > incident.timeToCheck) {
            if (incident.enabled && incident.runChecks()) {
                incident.trigger();
                // return false, so every frame triggers one incident only
                return false;
            }
            if (incident.enabled) {
                incident.enable(now + incident.checkInterval);
            }
            return true;
        }
        return false;
    };
    return IncidentManager;
}());
exports.IncidentManager = IncidentManager;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var RangedValue_1 = __webpack_require__(33);
var MathUtil_1 = __webpack_require__(4);
var Framework_1 = __webpack_require__(0);
var ArrayUtil_1 = __webpack_require__(1);
var GafManager_1 = __webpack_require__(13);
var ScrollControl = (function (_super) {
    __extends(ScrollControl, _super);
    function ScrollControl(_touchRect) {
        var _this = _super.call(this) || this;
        _this._scrollSpeed = 0;
        _this._lastScrollTime = 0;
        _this._scrollButtonInverse = false;
        _this._isScrollingPreventOtherTouch = false;
        _this._buttonsOfScrollingCheck = [];
        _this._isScrolling = false;
        _this._onScrollBar = false;
        _this.interactive = true;
        _this._touchRect = _touchRect;
        _this.createMask();
        _this._scrollNode = new PIXI.Container();
        _this.addChild(_this._scrollNode);
        _this.hitArea = _touchRect;
        return _this;
    }
    ScrollControl.prototype.createMask = function () {
        var mask = new PIXI.Graphics();
        mask.beginFill(0xFF0000, 0.5);
        mask.drawRect(this._touchRect.x, this._touchRect.y, this._touchRect.width, this._touchRect.height);
        mask.endFill();
        this.addChild(mask);
        this.mask = mask;
    };
    Object.defineProperty(ScrollControl.prototype, "scrollButtonInverse", {
        get: function () {
            return this._scrollButtonInverse;
        },
        set: function (value) {
            this._scrollButtonInverse = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollControl.prototype, "currentScroll", {
        get: function () {
            return this._currentScroll;
        },
        enumerable: true,
        configurable: true
    });
    ScrollControl.prototype.dispose = function () {
        this.offTouchTarget();
        this._touchTarget = null;
        Framework_1.FW.removeUpdateFunction(this, this.scrollUpdate);
        this.removeChildren();
        this._scrollNode.removeChildren();
        if (this.parent) {
            this.parent.removeChild(this);
        }
    };
    Object.defineProperty(ScrollControl.prototype, "scrollNode", {
        get: function () {
            return this._scrollNode;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollControl.prototype, "scrollButton", {
        get: function () {
            return this._scrollButton;
        },
        enumerable: true,
        configurable: true
    });
    ScrollControl.prototype.initScrollButton = function (button, moveRangeMin, moveRangeMax) {
        this._scrollButton = button;
        this._scrollButtonRange = new RangedValue_1.RangedValue(moveRangeMin, moveRangeMax);
    };
    ScrollControl.prototype.setScrollRange = function (min, max, _currentScroll) {
        this._scrollRange = new RangedValue_1.RangedValue(min, max);
        this.setCurrentScroll(this._scrollRange.restrictValue(_currentScroll), true);
    };
    Object.defineProperty(ScrollControl.prototype, "scrollRange", {
        get: function () {
            return this._scrollRange;
        },
        enumerable: true,
        configurable: true
    });
    ScrollControl.prototype.offTouchTarget = function () {
        if (this._touchTarget) {
            this._touchTarget
                .on('mousedown', this.onDragStart, this)
                .on('touchstart', this.onDragStart, this)
                .on('mouseup', this.onDragEnd, this)
                .on('mouseupoutside', this.onDragEnd, this)
                .on('touchend', this.onDragEnd, this)
                .on('touchendoutside', this.onDragEnd, this)
                .on('mousemove', this.onDragMove, this)
                .on('touchmove', this.onDragMove, this);
        }
        Framework_1.FW.removeUpdateFunction(this, this.scrollUpdate);
    };
    ScrollControl.prototype.start = function (touchTarget) {
        if (touchTarget === void 0) { touchTarget = null; }
        this.offTouchTarget();
        this._touchTarget = touchTarget ? touchTarget : this;
        this._touchTarget
            .on('mousedown', this.onDragStart, this)
            .on('touchstart', this.onDragStart, this)
            .on('mouseup', this.onDragEnd, this)
            .on('mouseupoutside', this.onDragEnd, this)
            .on('touchend', this.onDragEnd, this)
            .on('touchendoutside', this.onDragEnd, this)
            .on('mousemove', this.onDragMove, this)
            .on('touchmove', this.onDragMove, this);
        Framework_1.FW.addUpdateFunction(this, this.scrollUpdate);
        this.emit(ScrollControl.EVENT.SCROLL, this.scrollNodeValue);
    };
    ScrollControl.prototype.hitTest = function (localPoint) {
        var child = null;
        if (this.visible && this._touchRect.contains(localPoint.x, localPoint.y)) {
            var globalPoint = this.toGlobal(localPoint);
            child = Framework_1.FW.hitTest(globalPoint, this);
            if (child == null) {
                return this;
            }
        }
        return child;
    };
    ScrollControl.prototype.isScrollingPreventOtherTouch = function () {
        return this._isScrollingPreventOtherTouch;
    };
    ScrollControl.prototype.isScrolling = function () {
        return this._isScrolling;
    };
    ScrollControl.prototype.getPosValue = function (pos) {
        return pos.y;
    };
    ScrollControl.prototype.onDragStart = function (event) {
        var pos = event.data.getLocalPosition(this);
        this.startScroll(pos, this.isOnScrollBar(this.toGlobal(pos)));
    };
    ScrollControl.prototype.onDragMove = function (event) {
        if (this._scrollMouseStart == null)
            return;
        var pos = event.data.getLocalPosition(this);
        if (Math.abs(this.getPosValue(this._scrollMouseStart) - this.getPosValue(this._scrollTouch)) > 3 && !this._isScrollingPreventOtherTouch) {
            this.scrollNode.interactive = false;
            this._isScrollingPreventOtherTouch = true;
            this.makeUpStateOfButtonsOfScrolling();
        }
        if (this._onScrollBar) {
            var diff = this.getPosValue(pos) - this.getPosValue(this._scrollTouch);
            diff *= this._scrollRange.range / this._scrollButtonRange.range;
            this.setCurrentScroll(this._scrollRange.restrictValue(this._scrollStartValue - diff), true);
        }
        else {
            var speed = this.getPosValue(pos) - this.getPosValue(this._scrollTouch);
            this.setCurrentScroll(this.scrollNodeValue + speed, true);
            this._scrollTouch = pos;
            speed /= Math.max(1, -this._lastScrollTime);
            speed = speed > 0 ? Math.sqrt(speed) : -Math.sqrt(-speed);
            speed = Math.max(-20, Math.min(20, speed));
            this._scrollSpeed = MathUtil_1.MathUtil.numberFollowTarget(this._scrollSpeed, speed, 0.3, 1);
        }
        this._lastScrollTime = Framework_1.FW.time;
        //trace("pScrollSpeedY = " + pScrollSpeedY);
    };
    ScrollControl.prototype.onDragEnd = function (_event) {
        this.stopScroll();
    };
    ScrollControl.prototype.isOnScrollBar = function (globalPoint) {
        if (this._scrollButton && this._scrollButton.parent) {
            this._scrollButton.hitArea;
            return Framework_1.FW.hitTest(globalPoint, this._scrollButton) != null;
        }
        return false;
    };
    ScrollControl.prototype.setCurrentScroll = function (value, udpateNow) {
        this._currentScroll = this._scrollRange.restrictValue(value);
        if (udpateNow) {
            this.setScrollDisplay(value, 1);
        }
    };
    Object.defineProperty(ScrollControl.prototype, "scrollNodeValue", {
        get: function () {
            return this._scrollNode.y;
        },
        set: function (value) {
            this._scrollNode.y = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ScrollControl.prototype, "scrollButtonValue", {
        get: function () {
            return this._scrollButton ? this._scrollButton.y : Number.NaN;
        },
        set: function (value) {
            if (this._scrollButton)
                this._scrollButton.y = value;
        },
        enumerable: true,
        configurable: true
    });
    ScrollControl.prototype.setScrollDisplay = function (scroll, ratio) {
        if (ratio === void 0) { ratio = 0.3; }
        var wasScrolling = this._isScrolling;
        this._isScrolling = scroll != this.scrollNodeValue;
        if (this._isScrolling)
            this.scrollNodeValue = MathUtil_1.MathUtil.numberFollowTarget(this.scrollNodeValue, scroll, ratio, 1);
        if (this._scrollButtonRange) {
            if (this.scrollButtonInverse) {
                if (this._scrollRange.min == this._scrollRange.max)
                    this.scrollButtonValue = this._scrollButtonRange.max;
                else
                    this.scrollButtonValue = this._scrollButtonRange.calcValueInRange(this._scrollRange.calcPercentOfValue(this.scrollNodeValue));
            }
            else {
                if (this._scrollRange.min == this._scrollRange.max)
                    this.scrollButtonValue = this._scrollButtonRange.min;
                else
                    this.scrollButtonValue = this._scrollButtonRange.calcValueInRange(1 - this._scrollRange.calcPercentOfValue(this.scrollNodeValue));
            }
        }
        if (this._isScrolling)
            this.emit(ScrollControl.EVENT.SCROLL, this.scrollNodeValue);
        else if (wasScrolling)
            this.emit(ScrollControl.EVENT.SCROLLING_STOPPED);
    };
    ScrollControl.prototype.startScroll = function (pos, onScrollBar) {
        this._onScrollBar = onScrollBar;
        this._isScrollingPreventOtherTouch = false;
        this._scrollMouseStart = pos.clone();
        this._scrollTouch = pos;
        this._scrollSpeed = 0;
        this._currentScroll = this.scrollNodeValue;
        this._scrollStartValue = this._currentScroll;
        this._lastScrollTime = Framework_1.FW.time;
        this.emit(ScrollControl.EVENT.SCROLL_START);
    };
    ScrollControl.prototype.stopScroll = function () {
        this.scrollNode.interactive = true;
        this._isScrollingPreventOtherTouch = false;
        this._scrollTouch = null;
        this._scrollMouseStart = null;
        this.emit(ScrollControl.EVENT.SCROLL_END);
    };
    ScrollControl.prototype.scrollUpdate = function (dt) {
        if (this.visible && this.parent && !this._onScrollBar) {
            if (this._scrollSpeed != 0) {
                var decrase = 0.01;
                if (this._scrollSpeed > 0) {
                    this._scrollSpeed -= decrase * dt;
                    if (this._scrollSpeed <= 0) {
                        this._scrollSpeed = 0;
                    }
                }
                else {
                    this._scrollSpeed += decrase * dt;
                    if (this._scrollSpeed >= 0) {
                        this._scrollSpeed = 0;
                    }
                }
                if (this._scrollTouch == null) {
                    this.setCurrentScroll(this._currentScroll + this._scrollSpeed * dt, false);
                }
            }
            if (this._scrollTouch == null)
                this.setScrollDisplay(this._currentScroll);
        }
    };
    ScrollControl.prototype.addButtonOfScrollingCheck = function (button) {
        if (ArrayUtil_1.ArrayUtil.addUniqueElement(this._buttonsOfScrollingCheck, button)) {
            button.on(GafManager_1.Button.EVENT.STATE_CHANGE, function (state) {
                if (state == GafManager_1.Button.STATE.DOWN) {
                    if (ArrayUtil_1.ArrayUtil.removeElement(this._buttonsOfScrollingCheck, button)) {
                        // make it at the head of the array
                        this._buttonsOfScrollingCheck.unshift(button);
                    }
                }
            });
        }
    };
    ScrollControl.prototype.makeUpStateOfButtonsOfScrolling = function () {
        for (var _i = 0, _a = this._buttonsOfScrollingCheck; _i < _a.length; _i++) {
            var button = _a[_i];
            if (button.state == GafManager_1.Button.STATE.DOWN) {
                button.state = GafManager_1.Button.STATE.OUT;
            }
            else {
                break;
            }
        }
    };
    ScrollControl.EVENT = {
        SCROLL: "scroll",
        SCROLLING_STOPPED: "scrollingStopped",
        SCROLL_START: "scrollStart",
        SCROLL_END: "scrollEnd"
    };
    return ScrollControl;
}(PIXI.Container));
exports.ScrollControl = ScrollControl;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var GameTopic_1 = __webpack_require__(24);
var Framework_1 = __webpack_require__(0);
var PhysicsDebugDraw_1 = __webpack_require__(30);
var Point_1 = __webpack_require__(14);
var DisplayObjectUtil_1 = __webpack_require__(9);
var PhysicsSprite_1 = __webpack_require__(31);
var ArrayUtil_1 = __webpack_require__(1);
var PostOffice_1 = __webpack_require__(15);
var Physics = (function (_super) {
    __extends(Physics, _super);
    function Physics(fw) {
        var _this = _super.call(this) || this;
        _this.b2Scale = 30;
        _this._sprites = new Array();
        _this.stepVelocityIterations = 8;
        _this.stepPositionIterations = 3;
        _this._stepTimeScale = 0.001;
        _this.fw = fw;
        _this.stepTimeScale = 4;
        _this.reset();
        return _this;
    }
    Physics.prototype.convertB2VecToScreenPoint = function (vec) {
        return new Point_1.Point(vec.x * this.b2Scale, vec.y * this.b2Scale);
    };
    Object.defineProperty(Physics.prototype, "stepTimeScale", {
        get: function () {
            return this._stepTimeScale * 1000;
        },
        set: function (value) {
            this._stepTimeScale = value / 1000;
        },
        enumerable: true,
        configurable: true
    });
    Physics.prototype.createDebugRoot = function (_parent) {
        if (_parent && this._debugDraw == null) {
            this._debugDraw = new PhysicsDebugDraw_1.PhysicsDebugDraw(this);
            _parent.addChild(this._debugDraw.graphics);
        }
    };
    Object.defineProperty(Physics.prototype, "debugDraw", {
        get: function () {
            return this._debugDraw;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Physics.prototype, "world", {
        get: function () {
            if (this._world == null) {
                this._world = new b2World(new b2Vec2(0, 30 / this.b2Scale));
                window["world"] = this._world;
                this.fw.addUpdateFunction(this, this.update);
                this.setupCollisionResolver();
                if (this.fw.debugRoot && this._debugDraw == null) {
                    this.createDebugRoot(this.fw.debugRoot);
                }
            }
            return this._world;
        },
        enumerable: true,
        configurable: true
    });
    Physics.prototype.reset = function () {
        this.fw.removeUpdateFunction(this, this.update);
        if (this._world) {
            while (this._world.joints.length > 0) {
                this._world.DestroyJoint(this._world.joints[0]);
            }
            while (this._world.bodies.length > 0) {
                this._world.DestroyBody(this._world.bodies[0]);
            }
            while (this._world.particleSystems.length > 0) {
                this._world.DestroyParticleSystem(this._world.particleSystems[0]);
            }
            this._world = null;
            if (this._debugDraw) {
                this._debugDraw.dispose();
                this._debugDraw = null;
            }
        }
    };
    Physics.prototype.createPhysicsSprite = function (name, bodyoption) {
        return new PhysicsSprite_1.PhysicsSprite(this, name, bodyoption);
    };
    Physics.prototype.addPhysicSprite = function (sprite) {
        this._sprites.push(sprite);
    };
    Physics.prototype.listSprites = function () {
        return this._sprites;
    };
    Physics.prototype.update = function (_dt) {
        this.world.Step(1 / 20, this.stepVelocityIterations, this.stepPositionIterations);
        if (this._debugDraw) {
            DisplayObjectUtil_1.DisplayObjectUtil.setOnTopOfParent(this._debugDraw.graphics);
            this._debugDraw.draw();
        }
        for (var _i = 0, _a = this._sprites; _i < _a.length; _i++) {
            var sprite = _a[_i];
            sprite.update();
        }
    };
    Physics.prototype.addSprite = function (sprite) {
        ArrayUtil_1.ArrayUtil.addUniqueElement(this._sprites, sprite);
    };
    Physics.prototype.removeSprite = function (sprite) {
        ArrayUtil_1.ArrayUtil.removeElement(this._sprites, sprite);
    };
    Physics.prototype.containsSprite = function (sprite) {
        return this._sprites.indexOf(sprite) != -1;
    };
    Physics.prototype.setupCollisionResolver = function () {
        var getContactContext = function (fixture) {
            var context = fixture.userData;
            if (context && context["contactContext"])
                return context.contactContext;
            return context;
        };
        this._contactListener = {
            BeginContactBody: function (contact) {
                var contactObjA = getContactContext(contact.GetFixtureA());
                var contactObjB = getContactContext(contact.GetFixtureB());
                if (contactObjA && typeof contactObjA.onPhysicsContactBegin == "function")
                    contactObjA.onPhysicsContactBegin(contactObjB, contact);
                if (contactObjB && typeof contactObjB.onPhysicsContactBegin == "function")
                    contactObjB.onPhysicsContactBegin(contactObjA, contact);
                if (contact.IsEnabled()) {
                    Framework_1.FW.postOffice.sendMessage(null, GameTopic_1.GameTopic.CONTACT, new PostOffice_1.Message('contact', { names: [contactObjA.name, contactObjB.name] }));
                }
            },
            PreSolve: function (contact, oldManifold) {
                var contactObjA = getContactContext(contact.GetFixtureA());
                var contactObjB = getContactContext(contact.GetFixtureB());
                if (contactObjA && typeof contactObjA.onPhysicsContactPreSolve == "function")
                    contactObjA.onPhysicsContactPreSolve(contactObjB, contact, oldManifold);
                if (contactObjB && typeof contactObjB.onPhysicsContactPreSolve == "function")
                    contactObjB.onPhysicsContactPreSolve(contactObjA, contact, oldManifold);
            },
            PostSolve: function (contact, impulse) {
                var contactObjA = getContactContext(contact.GetFixtureA());
                var contactObjB = getContactContext(contact.GetFixtureB());
                if (contactObjA && typeof contactObjA.onPhysicsContactPostSolve == "function")
                    contactObjA.onPhysicsContactPostSolve(contactObjB, contact, impulse);
                if (contactObjB && typeof contactObjB.onPhysicsContactPostSolve == "function")
                    contactObjB.onPhysicsContactPostSolve(contactObjA, contact, impulse);
            },
            EndContactBody: function (contact) {
                var contactObjA = getContactContext(contact.GetFixtureA());
                var contactObjB = getContactContext(contact.GetFixtureB());
                if (contactObjA && typeof contactObjA.onPhysicsContactEnd == "function")
                    contactObjA.onPhysicsContactEnd(contactObjB, contact);
                if (contactObjB && typeof contactObjB.onPhysicsContactEnd == "function")
                    contactObjB.onPhysicsContactEnd(contactObjA, contact);
            }
        };
        this.world.SetContactListener(this._contactListener);
    };
    Physics.EVENT = {
        CONTACT: "contact"
    };
    return Physics;
}(PIXI.utils.EventEmitter));
exports.Physics = Physics;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var MathUtil_1 = __webpack_require__(4);
var DisplayObjectUtil_1 = __webpack_require__(9);
var PhysicsDebugDraw = (function () {
    function PhysicsDebugDraw(physcis) {
        this.physcis = physcis;
        this.circleVertices = [];
        this.particleVertices = [];
        this.circleResolution = 8;
        this.particleResolution = 3;
        this.color = 0xFFFF00;
        this.initCircleVertices = function (v, resolution) {
            var size = MathUtil_1.MathUtil.TWO_PI / resolution;
            for (var i = 0; i < resolution; i++) {
                var s1 = (i * size);
                var s2 = ((i + 1) * size);
                v.push(Math.cos(s1));
                v.push(Math.sin(s1));
                v.push(Math.cos(s2));
                v.push(Math.sin(s2));
            }
        };
        this._graphics = new PIXI.Graphics();
        this._graphics.scale.set(physcis.b2Scale, physcis.b2Scale);
        this.initCircleVertices(this.circleVertices, this.circleResolution);
        this.initCircleVertices(this.particleVertices, this.particleResolution);
        var renderer = this;
        b2CircleShape.prototype.draw = function (transform) {
            var circlePosition = this.position, center = new b2Vec2(circlePosition.x, circlePosition.y);
            renderer.insertCircleVertices(transform, this.radius, center.x, center.y);
        };
        b2ChainShape.prototype.draw = function (transform) {
            renderer.transformVerticesAndInsert(this.vertices, transform);
        };
        b2EdgeShape.prototype.draw = function (transform) {
            renderer.transformAndInsert(this.vertex1, this.vertex2, transform);
        };
        b2PolygonShape.prototype.draw = function (transform) {
            renderer.transformVerticesAndInsert(this.vertices, transform, true);
        };
    }
    Object.defineProperty(PhysicsDebugDraw.prototype, "graphics", {
        get: function () {
            return this._graphics;
        },
        enumerable: true,
        configurable: true
    });
    PhysicsDebugDraw.prototype.dispose = function () {
        this._graphics.clear();
        DisplayObjectUtil_1.DisplayObjectUtil.removeFromParent(this._graphics);
    };
    PhysicsDebugDraw.prototype.transformAndInsert = function (v1, v2, transform) {
        var transformedV1 = new b2Vec2(), transformedV2 = new b2Vec2();
        b2Vec2.Mul(transformedV1, transform, v1);
        b2Vec2.Mul(transformedV2, transform, v2);
        this.insertLine(transformedV1, transformedV2);
    };
    PhysicsDebugDraw.prototype.transformVerticesAndInsert = function (vertices, transform, closeShape) {
        if (closeShape === void 0) { closeShape = false; }
        var vertexCount = vertices.length;
        for (var i = 1; i < vertexCount; i++) {
            this.transformAndInsert(vertices[i - 1], vertices[i], transform);
        }
        if (closeShape) {
            this.transformAndInsert(vertices[vertexCount - 1], vertices[0], transform);
        }
    };
    PhysicsDebugDraw.prototype.insertCircleVertices = function (transform, radius, x, y) {
        var vertices = this.circleVertices;
        for (var i = 0; i <= this.circleResolution; ++i) {
            var i4 = i * 4;
            var v1 = new b2Vec2(vertices[i4] * radius + x, vertices[i4 + 1] * radius + y);
            var v2 = new b2Vec2(vertices[i4 + 2] * radius + x, vertices[i4 + 3] * radius + y);
            b2Vec2.Mul(v1, transform, v1);
            b2Vec2.Mul(v2, transform, v2);
            if (i == 0) {
                var center = new b2Vec2(x, y);
                b2Vec2.Mul(center, transform, center);
                this.insertLine(center, v1);
            }
            this.insertLine(v1, v2);
        }
    };
    PhysicsDebugDraw.prototype.insertLine = function (v1, v2) {
        this.graphics.moveTo(v1.x, v1.y);
        this.graphics.lineTo(v2.x, v2.y);
    };
    PhysicsDebugDraw.prototype.insertLine2 = function (v1x, v1y, v2x, v2y) {
        this.graphics.moveTo(v1x, v1y);
        this.graphics.lineTo(v2x, v2y);
    };
    PhysicsDebugDraw.prototype.insertParticleVertices = function (radius, x, y) {
        var vertices = this.particleVertices;
        for (var i = 0; i < this.particleResolution; i++) {
            var i4 = i * 4;
            var x1 = vertices[i4] * radius + x;
            var y1 = vertices[i4 + 1] * radius + y;
            var x2 = vertices[i4 + 2] * radius + x;
            var y2 = vertices[i4 + 3] * radius + y;
            this.insertLine2(x1, y1, x2, y2);
        }
    };
    PhysicsDebugDraw.prototype.drawParticleSystem = function (system) {
        var particles = system.GetPositionBuffer();
        var maxParticles = particles.length, transform = new b2Transform();
        transform.SetIdentity();
        for (var i = 0, c = 0; i < maxParticles; i += 2, c += 4) {
            this.insertParticleVertices(system.radius, particles[i], particles[i + 1]);
        }
    };
    PhysicsDebugDraw.prototype.draw = function () {
        this.graphics.clear();
        this.graphics.lineStyle(1 / this.physcis.b2Scale, this.color, 1);
        for (var i = 0, max = this.physcis.world.bodies.length; i < max; ++i) {
            var body = this.physcis.world.bodies[i];
            var maxFixtures = body.fixtures.length;
            var transform = body.GetTransform();
            for (var j = 0; j < maxFixtures; j++) {
                var fixture = body.fixtures[j];
                fixture.shape.draw(transform);
            }
        }
        for (var i = 0, max = this.physcis.world.joints.length; i < max; i++) {
            //let joint:b2Joint = this.physcis.world.joints[i];
        }
        // draw particle systems
        for (var i = 0, max = this.physcis.world.particleSystems.length; i < max; i++) {
            this.drawParticleSystem(this.physcis.world.particleSystems[i]);
        }
    };
    return PhysicsDebugDraw;
}());
exports.PhysicsDebugDraw = PhysicsDebugDraw;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Point_1 = __webpack_require__(14);
var DisplayObjectUtil_1 = __webpack_require__(9);
var PhysicsSprite = (function () {
    function PhysicsSprite(physics, name, bodyOptions) {
        this._name = "";
        this._fixedSpriteRotation = Number.NaN;
        this._spritePositionShift = new Point_1.Point(0, 0);
        this._spriteRotationShift = 0;
        this._fixtureTangentSpeed = new Map();
        this._bodyTangentSpeed = 0;
        this._userData = {};
        this._physics = physics;
        this._physics.addSprite(this);
        var def = new b2BodyDef();
        def.allowSleep = false;
        def.userData = this;
        this._name = name;
        if (bodyOptions.type == "dynamic") {
            def.type = b2_dynamicBody;
        }
        else {
            def.type = b2_staticBody;
        }
        if (bodyOptions.hasOwnProperty("linearDamping")) {
            def.linearDamping = bodyOptions["linearDamping"];
        }
        if (bodyOptions.hasOwnProperty("angularDamping")) {
            def.angularDamping = bodyOptions["angularDamping"];
        }
        if (bodyOptions.hasOwnProperty("fixedRotation")) {
            def.fixedRotation = bodyOptions["fixedRotation"];
        }
        if (bodyOptions.hasOwnProperty("linearVelocity")) {
            def.linearVelocity = bodyOptions["linearVelocity"].Clone();
            def.linearVelocity.Set(def.linearVelocity.x / this._physics.b2Scale, def.linearVelocity.y / this._physics.b2Scale);
        }
        if (bodyOptions.hasOwnProperty("angularVelocity")) {
            def.angularVelocity = bodyOptions["angularVelocity"];
        }
        this._body = this._physics.world.CreateBody(def);
        this.setPhysicsContactContext(this);
    }
    Object.defineProperty(PhysicsSprite.prototype, "userData", {
        get: function () {
            return this._userData;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "bodyTangentSpeed", {
        get: function () {
            return this._bodyTangentSpeed;
        },
        set: function (value) {
            this._bodyTangentSpeed = value;
        },
        enumerable: true,
        configurable: true
    });
    PhysicsSprite.prototype.setFixtureTangentSpeed = function (fixture, speed) {
        this._fixtureTangentSpeed.set(fixture, speed);
    };
    PhysicsSprite.prototype.getFixtureTangentSpeed = function (fixture) {
        return this._fixtureTangentSpeed.has(fixture) ? this._fixtureTangentSpeed.get(fixture) : 0;
    };
    Object.defineProperty(PhysicsSprite.prototype, "fixedSpriteRotation", {
        get: function () {
            return this._fixedSpriteRotation;
        },
        set: function (value) {
            this._fixedSpriteRotation = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "positionShift", {
        get: function () {
            return this._spritePositionShift;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "rotationShift", {
        get: function () {
            return this._spriteRotationShift;
        },
        set: function (value) {
            this._spriteRotationShift = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "contactContext", {
        get: function () {
            return this._contactContext ? this._contactContext : this;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "body", {
        get: function () {
            return this._body;
        },
        enumerable: true,
        configurable: true
    });
    PhysicsSprite.prototype.setPhysicsContactContext = function (context) {
        this._contactContext = context;
        for (var _i = 0, _a = this._body.fixtures; _i < _a.length; _i++) {
            var fixture = _a[_i];
            fixture.userData = context;
        }
    };
    PhysicsSprite.prototype.dispose = function () {
        DisplayObjectUtil_1.DisplayObjectUtil.removeFromParent(this.sprite);
        this.disposePhysics();
    };
    PhysicsSprite.prototype.disposePhysics = function () {
        if (this._physics.containsSprite(this)) {
            this._physics.world.DestroyBody(this._body);
            this._physics.removeSprite(this);
        }
    };
    PhysicsSprite.prototype.setPosition = function (x, y) {
        this._body.SetTransform(new b2Vec2(x / this._physics.b2Scale, y / this._physics.b2Scale), this._body.GetAngle());
        this.updateSprite();
    };
    PhysicsSprite.prototype.getPosition = function () {
        return new Point_1.Point(this.x, this.y);
    };
    Object.defineProperty(PhysicsSprite.prototype, "x", {
        get: function () {
            return this._body.GetPosition().x * this._physics.b2Scale;
        },
        set: function (value) {
            this.setPosition(value / this._physics.b2Scale, this._body.GetPosition().y);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhysicsSprite.prototype, "y", {
        get: function () {
            return this._body.GetPosition().y * this._physics.b2Scale;
        },
        set: function (value) {
            this.setPosition(this._body.GetPosition().x, value / this._physics.b2Scale);
        },
        enumerable: true,
        configurable: true
    });
    PhysicsSprite.prototype.setAngle = function (radians) {
        this._body.SetTransform(this._body.GetPosition(), radians);
        this.updateSprite();
    };
    PhysicsSprite.prototype._createFixtureDef = function (shape, options) {
        options = options || {};
        var def = new b2FixtureDef();
        def.shape = shape;
        if (options.hasOwnProperty("density"))
            def.density = this.getNumber(options["density"]);
        if (options.hasOwnProperty("friction"))
            def.friction = this.getNumber(options["friction"]);
        if (options.hasOwnProperty("restitution"))
            def.restitution = this.getNumber(options["restitution"]);
        if (options.hasOwnProperty("isSensor"))
            def.isSensor = options["isSensor"];
        if (options.hasOwnProperty("categoryBits"))
            def.filter.categoryBits = options["categoryBits"];
        if (options.hasOwnProperty("maskBits"))
            def.filter.maskBits = parseInt(options["maskBits"]);
        if (options.hasOwnProperty("groupIndex"))
            def.filter.groupIndex = parseInt(options["groupIndex"]);
        if (this._contactContext)
            def.userData = this._contactContext;
        return def;
    };
    PhysicsSprite.prototype.getNumber = function (value) {
        if (typeof value == 'string') {
            return parseFloat(value);
        }
        return value;
    };
    PhysicsSprite.prototype.addEdge = function (p1, p2, fixtureOptions) {
        if (fixtureOptions === void 0) { fixtureOptions = null; }
        var shape = new b2EdgeShape();
        shape.Set(p1.toScaledB2Vec2(1 / this._physics.b2Scale), p2.toScaledB2Vec2(1 / this._physics.b2Scale));
        return this._body.CreateFixtureFromDef(this._createFixtureDef(shape, fixtureOptions));
    };
    PhysicsSprite.prototype.addCircle = function (localX, localY, radius, fixtureOptions) {
        if (fixtureOptions === void 0) { fixtureOptions = null; }
        var shape = new b2CircleShape();
        shape.radius = radius / this._physics.b2Scale;
        shape.position.Set(localX / this._physics.b2Scale, localY / this._physics.b2Scale);
        return this._body.CreateFixtureFromDef(this._createFixtureDef(shape, fixtureOptions));
    };
    PhysicsSprite.prototype.addBox = function (localX, localY, halfWidth, halfHeight, fixtureOptions) {
        if (fixtureOptions === void 0) { fixtureOptions = null; }
        var box = new b2PolygonShape();
        box.SetAsBoxXYCenterAngle(halfWidth / this._physics.b2Scale, halfHeight / this._physics.b2Scale, new b2Vec2(localX / this._physics.b2Scale, localY / this._physics.b2Scale), 0);
        return this._body.CreateFixtureFromDef(this._createFixtureDef(box, fixtureOptions));
    };
    PhysicsSprite.prototype.addPolygon = function (points, fixtureOptions) {
        if (fixtureOptions === void 0) { fixtureOptions = null; }
        var polygon = new b2PolygonShape();
        var vecs = [];
        for (var i in points) {
            vecs[i] = points[i].toScaledB2Vec2(1 / this._physics.b2Scale);
        }
        polygon.vertices = vecs;
        return this._body.CreateFixtureFromDef(this._createFixtureDef(polygon, fixtureOptions));
    };
    PhysicsSprite.prototype.update = function () {
        this.updateSprite();
    };
    PhysicsSprite.prototype.updateSprite = function () {
        if (this.sprite) {
            this.sprite.x = this.x + this._spritePositionShift.x;
            this.sprite.y = this.y + this._spritePositionShift.y;
            if (isNaN(this.fixedSpriteRotation)) {
                //if(this.name == 'mover')
                //console.log(this.name + ', angle = ' + this._body.GetAngle());
                this.sprite.rotation = this._body.GetAngle() + this._spriteRotationShift;
            }
            else {
                this.sprite.rotation = this.fixedSpriteRotation;
            }
        }
    };
    /**
       * contact callbacks
       */
    PhysicsSprite.prototype.onPhysicsContactBegin = function (_obj, _contact) { };
    ;
    PhysicsSprite.prototype.onPhysicsContactPreSolve = function (_obj, _contact, _oldManifold) {
        if (this.bodyTangentSpeed) {
            _contact.SetTangentSpeed(this.bodyTangentSpeed);
        }
        else {
            var speed = this.getFixtureTangentSpeed(_contact.GetFixtureA()) || this.getFixtureTangentSpeed(_contact.GetFixtureB());
            if (speed) {
                _contact.SetTangentSpeed(speed);
            }
        }
    };
    ;
    PhysicsSprite.prototype.onPhysicsContactPostSolve = function (_obj, _contact, _impulse) { };
    ;
    PhysicsSprite.prototype.onPhysicsContactEnd = function (_obj, _contact) { };
    ;
    return PhysicsSprite;
}());
exports.PhysicsSprite = PhysicsSprite;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IntUtil = (function () {
    function IntUtil() {
    }
    IntUtil.random = function (max) {
        return Math.floor(Math.random() * (max + 1));
    };
    IntUtil.randomBetween = function (min, max) {
        return min + Math.floor(Math.random() * (max - min + 1));
    };
    return IntUtil;
}());
exports.IntUtil = IntUtil;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RandomGenerator_1 = __webpack_require__(18);
var RangedValue = (function () {
    function RangedValue(min, max) {
        this._min = Math.min(min, max);
        this._max = Math.max(min, max);
    }
    RangedValue.fromString = function (str) {
        if (str) {
            var arr = str.split(",");
            if (arr.length) {
                var value0 = parseFloat(arr[0]);
                if (arr.length == 1) {
                    return new RangedValue(value0, value0);
                }
                var value1 = parseFloat(arr[1]);
                return new RangedValue(value0, value1);
            }
        }
        return new RangedValue(0, 0);
    };
    Object.defineProperty(RangedValue.prototype, "min", {
        get: function () {
            return this._min;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RangedValue.prototype, "max", {
        get: function () {
            return this._max;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RangedValue.prototype, "range", {
        get: function () {
            return this._max - this._min;
        },
        enumerable: true,
        configurable: true
    });
    RangedValue.prototype.calcValueInRange = function (percent) {
        if (percent <= 0)
            return this._min;
        if (percent >= 1)
            return this._max;
        return this._min + percent * this.range;
    };
    RangedValue.prototype.calcPercentOfValue = function (value) {
        if (value <= this._min)
            return 0;
        if (value >= this._max)
            return 1;
        return (value - this._min) / this.range;
    };
    RangedValue.prototype.getRandomInRange = function (rng) {
        if (rng === void 0) { rng = null; }
        if (rng == null)
            rng = new RandomGenerator_1.SystemRandomGenerator();
        return rng.nextBetween(this._min, this._max);
    };
    RangedValue.prototype.isValueInRange = function (value) {
        return value >= this._min && value <= this._max;
    };
    RangedValue.prototype.restrictValue = function (value) {
        return Math.max(this._min, Math.min(this._max, value));
    };
    return RangedValue;
}());
exports.RangedValue = RangedValue;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var app_base_1 = __webpack_require__(10);
var NetUtil_1 = __webpack_require__(17);
var LevelInfo_1 = __webpack_require__(8);
var UserRecord_1 = __webpack_require__(3);
var IframeObject_1 = __webpack_require__(35);
var Framework_1 = __webpack_require__(0);
var GameHost = (function () {
    function GameHost(level) {
        this.level = level;
    }
    GameHost.prototype.execute = function () {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            Framework_1.FW.root.visible = false;
            Framework_1.FW.setActive(false);
            _this.startIframe()
                .then(function (nextLevel) {
                Framework_1.FW.root.visible = true;
                Framework_1.FW.setActive(true);
                resolve(nextLevel);
            });
        });
    };
    Object.defineProperty(GameHost.prototype, "iframeSrc", {
        get: function () {
            var url = '/fso5/game.html?level=' + this.level;
            if (app_base_1.AppBase.debug) {
                url += '&debug=' + NetUtil_1.NetUtil.getQueryStringValue('debug');
            }
            return url;
        },
        enumerable: true,
        configurable: true
    });
    GameHost.prototype.startIframe = function () {
        var _this = this;
        var debug = location.hostname === 'localhost';
        if (debug) {
            return this.debugExecute();
        }
        var iframeobj = new IframeObject_1.IframeObject();
        iframeobj.setDimension(0, 0, "100%", "100%");
        return iframeobj.start(this.iframeSrc, function (recordJson) {
            if (recordJson) {
                UserRecord_1.userRecord.setLevelRecord(_this.level, new UserRecord_1.LevelRecord(_this.level, recordJson));
            }
        });
    };
    GameHost.prototype.debugExecute = function () {
        var _this = this;
        return new Promise(function (resolve) {
            setTimeout(function () {
                var fail = false;
                if (fail) {
                    resolve(null);
                }
                else {
                    var record = new UserRecord_1.LevelRecord(_this.level, {});
                    record.stars = 2;
                    record.time = 3600;
                    UserRecord_1.userRecord.setLevelRecord(_this.level, record);
                    var lv = LevelInfo_1.LevelInfo.fromString(_this.level);
                    resolve(lv.getNeighbor(1).level);
                }
            }, 1000);
        });
    };
    return GameHost;
}());
exports.GameHost = GameHost;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Framework_1 = __webpack_require__(0);
var ObjectBase_1 = __webpack_require__(12);
var UserRecord_1 = __webpack_require__(3);
var IframeObject = (function (_super) {
    __extends(IframeObject, _super);
    function IframeObject() {
        var _this = _super.call(this) || this;
        _this.iframe = document.createElement("iframe");
        return _this;
    }
    IframeObject.prototype.start = function (src, recordCallback) {
        var _this = this;
        return new Promise(function (resolve, _reject) {
            _this.iframe.setAttribute('src', src);
            document.body.appendChild(_this.iframe);
            var listener = postRobot.listener({ window: _this.iframe.contentWindow, domain: '*' });
            listener.on('closeGame', function (event) {
                _this.delayClose();
                UserRecord_1.userRecord.refresh();
                resolve(event.data.nextLevel);
            });
            listener.on('gameResult', function (event) {
                UserRecord_1.userRecord.refresh();
                recordCallback(event.data.record);
            });
            listener.on('gameInited', function (_event) {
                _this.iframe.contentWindow.focus();
            });
        });
    };
    IframeObject.prototype.delayClose = function () {
        var _this = this;
        this.iframe.style.visibility = 'hidden';
        Framework_1.FW.addDelayFunction(null, function () {
            _this.dispose();
        }, null, 500);
    };
    IframeObject.prototype.setDimension = function (x, y, width, height) {
        this.iframe.setAttribute('style', 'position:fixed;top:' + x + 'px;left:' + y + 'px');
        this.iframe.setAttribute('width', width);
        this.iframe.setAttribute('height', height);
    };
    IframeObject.prototype.dispose = function () {
        if (this.iframe) {
            document.body.removeChild(this.iframe);
            this.iframe = null;
        }
        _super.prototype.dispose.call(this);
    };
    return IframeObject;
}(ObjectBase_1.ObjectBase));
exports.IframeObject = IframeObject;


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// world.2kozu2.bundle.js